function X() {
}
function ft(t) {
  return t();
}
function mt() {
  return /* @__PURE__ */ Object.create(null);
}
function ve(t) {
  t.forEach(ft);
}
function st(t) {
  return typeof t == "function";
}
function xe(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let Pe;
function de(t, e) {
  return Pe || (Pe = document.createElement("a")), Pe.href = e, t === Pe.href;
}
function mn(t) {
  return Object.keys(t).length === 0;
}
function bn(t, ...e) {
  if (t == null)
    return X;
  const n = t.subscribe(...e);
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
function ye(t, e, n) {
  t.$$.on_destroy.push(bn(e, n));
}
function Me(t, e, n) {
  return t.set(n), e;
}
function f(t, e) {
  t.appendChild(e);
}
function w(t, e, n) {
  t.insertBefore(e, n || null);
}
function z(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function He(t, e) {
  for (let n = 0; n < t.length; n += 1)
    t[n] && t[n].d(e);
}
function v(t) {
  return document.createElement(t);
}
function S(t) {
  return document.createElementNS("http://www.w3.org/2000/svg", t);
}
function O(t) {
  return document.createTextNode(t);
}
function D() {
  return O(" ");
}
function Ie() {
  return O("");
}
function se(t, e, n, r) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n, r);
}
function pn(t) {
  return function(e) {
    return e.preventDefault(), t.call(this, e);
  };
}
function a(t, e, n) {
  n == null ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
}
function fe(t, e, n) {
  e in t ? t[e] = typeof t[e] == "boolean" && n === "" ? !0 : n : a(t, e, n);
}
function Ne(t, e, n) {
  t.setAttributeNS("http://www.w3.org/1999/xlink", e, n);
}
function hn(t) {
  return Array.from(t.childNodes);
}
function P(t, e) {
  e = "" + e, t.data !== e && (t.data = e);
}
function bt(t, e) {
  t.value = e ?? "";
}
function $e(t, e, n, r) {
  n === null ? t.style.removeProperty(e) : t.style.setProperty(e, n, r ? "important" : "");
}
function Ze(t, e, n) {
  for (let r = 0; r < t.options.length; r += 1) {
    const l = t.options[r];
    if (l.__value === e) {
      l.selected = !0;
      return;
    }
  }
  (!n || e !== void 0) && (t.selectedIndex = -1);
}
function pt(t) {
  const e = t.querySelector(":checked");
  return e && e.__value;
}
class gn {
  constructor(e = !1) {
    this.is_svg = !1, this.is_svg = e, this.e = this.n = null;
  }
  c(e) {
    this.h(e);
  }
  m(e, n, r = null) {
    this.e || (this.is_svg ? this.e = S(n.nodeName) : this.e = v(n.nodeType === 11 ? "TEMPLATE" : n.nodeName), this.t = n.tagName !== "TEMPLATE" ? n : n.content, this.c(e)), this.i(r);
  }
  h(e) {
    this.e.innerHTML = e, this.n = Array.from(this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes);
  }
  i(e) {
    for (let n = 0; n < this.n.length; n += 1)
      w(this.t, this.n[n], e);
  }
  p(e) {
    this.d(), this.h(e), this.i(this.a);
  }
  d() {
    this.n.forEach(z);
  }
}
function Ge(t) {
  const e = {};
  for (const n of t)
    e[n.name] = n.value;
  return e;
}
let De;
function Ae(t) {
  De = t;
}
function tt() {
  if (!De)
    throw new Error("Function called outside component initialization");
  return De;
}
function nt(t) {
  tt().$$.on_mount.push(t);
}
const Se = [], ct = [];
let Ee = [];
const ht = [], _n = /* @__PURE__ */ Promise.resolve();
let dt = !1;
function vn() {
  dt || (dt = !0, _n.then(me));
}
function Be(t) {
  Ee.push(t);
}
const lt = /* @__PURE__ */ new Set();
let Le = 0;
function me() {
  if (Le !== 0)
    return;
  const t = De;
  do {
    try {
      for (; Le < Se.length; ) {
        const e = Se[Le];
        Le++, Ae(e), yn(e.$$);
      }
    } catch (e) {
      throw Se.length = 0, Le = 0, e;
    }
    for (Ae(null), Se.length = 0, Le = 0; ct.length; )
      ct.pop()();
    for (let e = 0; e < Ee.length; e += 1) {
      const n = Ee[e];
      lt.has(n) || (lt.add(n), n());
    }
    Ee.length = 0;
  } while (Se.length);
  for (; ht.length; )
    ht.pop()();
  dt = !1, lt.clear(), Ae(t);
}
function yn(t) {
  if (t.fragment !== null) {
    t.update(), ve(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(Be);
  }
}
function kn(t) {
  const e = [], n = [];
  Ee.forEach((r) => t.indexOf(r) === -1 ? e.push(r) : n.push(r)), n.forEach((r) => r()), Ee = e;
}
const wn = /* @__PURE__ */ new Set();
function zn(t, e) {
  t && t.i && (wn.delete(t), t.i(e));
}
const Tn = [
  "allowfullscreen",
  "allowpaymentrequest",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "defer",
  "disabled",
  "formnovalidate",
  "hidden",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "selected"
];
[...Tn];
function Mn(t, e, n, r) {
  const { fragment: l, after_update: i } = t.$$;
  l && l.m(e, n), r || Be(() => {
    const o = t.$$.on_mount.map(ft).filter(st);
    t.$$.on_destroy ? t.$$.on_destroy.push(...o) : ve(o), t.$$.on_mount = [];
  }), i.forEach(Be);
}
function Nn(t, e) {
  const n = t.$$;
  n.fragment !== null && (kn(n.after_update), ve(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
}
function Ln(t, e) {
  t.$$.dirty[0] === -1 && (Se.push(t), vn(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function Re(t, e, n, r, l, i, o, s = [-1]) {
  const d = De;
  Ae(t);
  const c = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: i,
    update: X,
    not_equal: l,
    bound: mt(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (d ? d.$$.context : [])),
    // everything else
    callbacks: mt(),
    dirty: s,
    skip_bound: !1,
    root: e.target || d.$$.root
  };
  o && o(c.root);
  let m = !1;
  if (c.ctx = n ? n(t, e.props || {}, (u, b, ..._) => {
    const p = _.length ? _[0] : b;
    return c.ctx && l(c.ctx[u], c.ctx[u] = p) && (!c.skip_bound && c.bound[u] && c.bound[u](p), m && Ln(t, u)), b;
  }) : [], c.update(), m = !0, ve(c.before_update), c.fragment = r ? r(c.ctx) : !1, e.target) {
    if (e.hydrate) {
      const u = hn(e.target);
      c.fragment && c.fragment.l(u), u.forEach(z);
    } else
      c.fragment && c.fragment.c();
    e.intro && zn(t.$$.fragment), Mn(t, e.target, e.anchor, e.customElement), me();
  }
  Ae(d);
}
let je;
typeof HTMLElement == "function" && (je = class extends HTMLElement {
  constructor() {
    super(), this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    const { on_mount: t } = this.$$;
    this.$$.on_disconnect = t.map(ft).filter(st);
    for (const e in this.$$.slotted)
      this.appendChild(this.$$.slotted[e]);
  }
  attributeChangedCallback(t, e, n) {
    this[t] = n;
  }
  disconnectedCallback() {
    ve(this.$$.on_disconnect);
  }
  $destroy() {
    Nn(this, 1), this.$destroy = X;
  }
  $on(t, e) {
    if (!st(e))
      return X;
    const n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return n.push(e), () => {
      const r = n.indexOf(e);
      r !== -1 && n.splice(r, 1);
    };
  }
  $set(t) {
    this.$$set && !mn(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
});
const Ce = [];
function rt(t, e = X) {
  let n;
  const r = /* @__PURE__ */ new Set();
  function l(s) {
    if (xe(t, s) && (t = s, n)) {
      const d = !Ce.length;
      for (const c of r)
        c[1](), Ce.push(c, t);
      if (d) {
        for (let c = 0; c < Ce.length; c += 2)
          Ce[c][0](Ce[c + 1]);
        Ce.length = 0;
      }
    }
  }
  function i(s) {
    l(s(t));
  }
  function o(s, d = X) {
    const c = [s, d];
    return r.add(c), r.size === 1 && (n = e(l) || X), s(t), () => {
      r.delete(c), r.size === 0 && n && (n(), n = null);
    };
  }
  return { set: l, update: i, subscribe: o };
}
const qe = (t, e) => {
  if (!t)
    return "0";
  const n = t - e, r = Math.floor(n / (1e3 * 60 * 60 * 24)), l = Math.floor(n % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)), i = Math.floor(n % (1e3 * 60 * 60) / (1e3 * 60)), o = Math.floor(n % (1e3 * 60) / 1e3);
  let s = "";
  return r > 0 && (s += `${r}D `), (r > 0 || l > 0) && (s += `${l}H `), (r > 0 || l > 0 || i > 0) && (s += `${i}M `), (r > 0 || l > 0 || i > 0 || o >= 0) && (s += `${o}S `), s.length === 0 ? "0" : s;
}, ue = async (t, e) => {
  const n = {
    method: (e == null ? void 0 : e.method) || "GET",
    headers: (e == null ? void 0 : e.headers) || void 0,
    body: e != null && e.body ? JSON.stringify(e.body) : void 0
  }, r = {}, l = e ? !!e.blob : !1;
  e != null && e.baseUrl && (t = e.baseUrl + t), e != null && e.params && (t += `?${new URLSearchParams(e.params).toString()}`);
  try {
    const i = performance.now(), o = await fetch(t, { ...n }), s = l ? await o.blob() : await o.json();
    for (const [c, m] of o.headers.entries())
      r[c] = m;
    const d = performance.now();
    return { data: s, error: null, headers: r, time: d - i };
  } catch (i) {
    return {
      data: null,
      headers: r,
      error: i,
      time: 0
    };
  }
}, Ve = /* @__PURE__ */ new Map(), an = async (t, e, n = 6e5, r = !1) => {
  r && Ve.get(t) && Ve.delete(t);
  const l = Ve.get(t) || { ts: 0, val: null, promise: null };
  if (!l.promise && Date.now() - l.ts > n) {
    l.promise = e(l.val);
    try {
      l.ts = Date.now(), l.val = await l.promise;
    } catch (i) {
      throw new Error(i);
    } finally {
      l.promise = null;
    }
  }
  return Ve.set(t, l), l.promise && !l.ts && await l.promise, l.val;
}, Cn = ({
  retries: t = 3,
  delay: e = 1e3,
  retryOn: n,
  call: r
}) => {
  let l = 0;
  const i = async () => {
    const o = await r();
    return o.error ? o : n(o.data) && l < t ? (l++, await new Promise((s) => setTimeout(s, e)), i()) : o;
  };
  return i();
}, We = (t, e = 8, n = !1) => {
  const r = typeof t == "number" ? t : parseFloat(t);
  return Number.isNaN(r) ? "0" : r.toLocaleString("EN", {
    maximumFractionDigits: e,
    minimumFractionDigits: n ? e : 0
  });
};
/*!
 * Suggestify
 * (c) Max van der Schee
 * @license MIT
 */
const Sn = ({ items: t, sorted_items: e, options: n }) => {
  const r = {
    distance: 3,
    results_count: 8,
    results_count_alt: 32,
    ...n
  };
  return function(o) {
    const s = new RegExp(o.replace(/\s+/g, "|"), "i"), d = o.charAt(0), c = e != null && e[d] ? e[d] : [], m = {
      match: [],
      alt: []
    }, u = (h) => {
      s.test(h) && m.match.push(h);
    }, b = (h) => {
      i(h, o || "") <= r.distance && m.alt.push(h);
    }, _ = () => m.match.length >= r.results_count, p = () => m.alt.length >= r.results_count_alt, g = c.length;
    for (let h = 0; h < g && (u(c[h]), b(c[h]), !(_() || p())); h++)
      ;
    if (!(_() || p())) {
      const h = t.length;
      for (let L = 0; L < h && (u(t[L]), b(t[L]), !(_() || p())); L++)
        ;
    }
    return [.../* @__PURE__ */ new Set([...l(o, m.match), ...l(o, m.alt)])].slice(0, r.results_count);
  };
  function l(o, s) {
    return s.sort((d, c) => {
      const m = i(o, d), u = i(o, c);
      return m > u ? 1 : m < u ? -1 : 0;
    });
  }
  function i(o, s) {
    if (!o.length)
      return s.length;
    if (!s.length)
      return o.length;
    const d = s.length, c = o.length, m = [];
    for (let u = 0; u <= d; u++) {
      m[u] = [u];
      for (let b = 1; b <= c; b++)
        m[u][b] = u === 0 ? b : Math.min(
          m[u - 1][b] + 1,
          m[u][b - 1] + 1,
          m[u - 1][b - 1] + (o[b - 1] === s[u - 1] ? 0 : 1)
        );
    }
    return m[d][c];
  }
}, pe = (t) => {
  const { immutable_data: e, data: n, template: r } = t;
  return n || e || (r && r.immutable_data ? r.immutable_data : null);
}, ae = (t, e = 300, n = !1) => `https://resizer.neftyblocks.com?ipfs=${encodeURIComponent(t)}&width=${e}&static=${n}`, En = ({
  account: t,
  contract: e,
  blend_id: n,
  asset_ids: r,
  tokens: l,
  balance_asset_ids: i,
  security_check: o
}) => {
  const { actor: s, permission: d } = t, c = [], m = [], u = [];
  if (l.length > 0)
    for (let b = 0; b < l.length; b++) {
      const { token_precision: _, token_symbol: p, token_contract: g, value: h } = l[b];
      m.push(
        {
          account: e,
          name: "openbal",
          authorization: [
            {
              actor: s,
              permission: d
            }
          ],
          data: {
            owner: s,
            token_symbol: `${_},${p}`
          }
        },
        {
          account: g,
          name: "transfer",
          authorization: [
            {
              actor: s,
              permission: d
            }
          ],
          data: {
            from: s,
            to: e,
            quantity: `${h.toFixed(_)} ${p}`,
            memo: "deposit"
          }
        }
      );
    }
  if (r.length > 0 && u.push(
    {
      account: e,
      name: "announcedepo",
      authorization: [
        {
          actor: s,
          permission: d
        }
      ],
      data: {
        owner: s,
        count: r.length
      }
    },
    {
      account: "atomicassets",
      name: "transfer",
      authorization: [
        {
          actor: s,
          permission: d
        }
      ],
      data: {
        from: s,
        to: e,
        asset_ids: r,
        memo: "deposit"
      }
    }
  ), e === "blenderizerx" && c.push({
    account: "atomicassets",
    name: "transfer",
    authorization: [
      {
        actor: s,
        permission: d
      }
    ],
    data: {
      from: s,
      to: e,
      asset_ids: r,
      memo: n
    }
  }), e === "blend.nefty") {
    const b = o ? { security_check: o } : {};
    c.push(...m, ...u, {
      account: e,
      name: o ? "fuse" : "nosecfuse",
      authorization: [
        {
          actor: s,
          permission: d
        }
      ],
      data: {
        claimer: s,
        blend_id: n,
        transferred_assets: r,
        own_assets: i,
        ...b
      }
    });
  }
  return e === "craft.tag" && (o ? c.push(...m, ...u, {
    account: e,
    name: "fuse",
    authorization: [
      {
        actor: s,
        permission: d
      }
    ],
    data: {
      claimer: s,
      blend_id: n,
      transferred_assets: r,
      own_assets: i,
      security_check: o
    }
  }) : c.push({
    account: "atomicassets",
    name: "transfer",
    authorization: [
      {
        actor: s,
        permission: d
      }
    ],
    data: {
      from: s,
      to: e,
      asset_ids: r,
      memo: `blend:${n}`
    }
  })), c;
}, sn = (t, e = 8) => +t / Math.pow(10, e), gt = (t, e = 8) => {
  const [n] = t.split(" ");
  return We(n, e);
}, _e = (t, e, n) => {
  const r = qe(t, n), l = qe(e, n);
  if (t !== 0)
    return r === "0" ? +e != 0 ? l === "0" ? "ended" : `ending ${l}` : "live" : `${r}`;
}, ke = (t) => t.split("-").join(" "), xn = (t) => {
  const e = Math.floor(t / 86400), n = Math.floor(t % (3600 * 24) / 3600), r = Math.floor(t % 3600 / 60), l = Math.floor(t % 60), i = e > 0 ? `${e}D` : "", o = n > 0 ? `${n}H` : "", s = r > 0 ? `${r}M` : "", d = l > 0 ? `${l}S` : "";
  return i + o + s + d;
}, cn = (t, e) => {
  let n, r, l;
  if (t && (l = t.name, n = t.image), e != null && e.template) {
    const i = pe(e.template), { name: o } = i, { image: s, video: d } = we(
      i,
      e.template.schema.format
    );
    l || (l = o), n || (n = s), !n && !r && (r = d);
  } else if (e != null && e.pool) {
    const i = e.pool.display_data ? JSON.parse(e.pool.display_data) : null;
    i && (l || (l = i.name), n || (n = i.image), !n && !r && (r = i.video));
  }
  return { blend_name: l, blend_img: n, blend_video: r };
}, we = (t, e) => {
  const n = {
    image: null,
    video: null
  };
  if (e)
    for (let r = 0; r < e.length; r++) {
      const { name: l, type: i } = e[r], o = l.toLowerCase();
      t[l] && (o.startsWith("im") || o.includes("img") ? n.image || (n.image = t[l]) : (o.startsWith("vid") || o.includes("vid")) && (n.video || (n.video = t[l])));
    }
  else {
    const r = Object.keys(t);
    for (let l = 0; l < r.length; l++) {
      const i = r[l].toLowerCase();
      t[r[l]] && (i.startsWith("im") || i.includes("img") ? n.image || (n.image = t[r[l]]) : (i.startsWith("vid") || i.includes("vid")) && (n.video || (n.video = t[r[l]])));
    }
  }
  return n;
}, it = [
  "rarity",
  "Rarity",
  "variation",
  "Variation",
  "style",
  "Style"
], Ue = (t) => {
  for (let e = 0; e < it.length; e++)
    if (t[it[e]])
      return t[it[e]];
  return null;
}, Fe = (t, e, n) => {
  const { amount: r } = e;
  return t ? !n && t.length ? !0 : !(r > t.length) : !1;
}, dn = (t, e) => {
  const { value: n } = e;
  if (!t)
    return !1;
  const [r] = t.split(" ");
  return n <= +r;
}, Xe = (t, e, n) => {
  const r = e.split("|"), l = "&sort=price&order=asc", i = `${n}/marketplace/listing`;
  return {
    attributes: `${i}?collection_name=${r[0]}&schema_name=${r[1]}${l}`,
    collection: `${i}?collection_name=${r[0]}${l}`,
    schema: `${i}?collection_name=${r[0]}&schema_name=${r[1]}${l}`,
    template: `${i}?collection_name=${r[0]}&template_id=${r[1]}${l}`,
    balance: `${i}?collection_name=${r[0]}&template_id=${r[1]}${l}`
  }[t];
}, Qe = (t, e, n) => {
  const r = e.split("|");
  return {
    attributes: `${n}/schemas/${r[0]}/${r[1]}`,
    collection: `${n}/collection/${r[0]}`,
    schema: `${n}/schemas/${r[0]}/${r[1]}`,
    template: `${n}/templates/${r[0]}/${r[1]}`,
    balance: `${n}/templates/${r[0]}/${r[1]}`
  }[t];
}, In = (t) => t <= 1 ? "legendary" : t <= 5 ? "epic" : t <= 10 ? "rare" : t <= 25 ? "uncommon" : "common", Je = "You do not hold enough", jn = {
  TOKEN_HOLDING: `${Je} tokens`,
  TEMPLATE_HOLDINGS: `${Je} NFTs from a template`,
  COLLECTION_HOLDINGS: `${Je} NFTs from a collection`,
  SCHEMA_HOLDINGS: `${Je} NFTs from a schema`,
  "": ""
}, fn = {
  0: (t, e) => t === e,
  1: (t, e) => t !== e,
  2: (t, e) => t > e,
  3: (t, e) => t >= e,
  4: (t, e) => t < e,
  5: (t, e) => t <= e
}, An = (t, e = "_default") => (n) => (t[n] || t[e])(), Te = (t, e, n) => {
  const r = qe(+t, n), l = qe(+e, n);
  return t === "0" && e === "0" || t === "0" && l !== "0" || e === "0" && r === "0" ? !0 : r === "0" && l !== "0";
}, _t = (t) => {
  const e = Object.values(t);
  return e.sort((n, r) => n.matcher_type === "balance" ? -1 : r.matcher_type === "balance" ? 1 : n.matcher_type === "attributes" ? -1 : r.matcher_type === "attributes" ? 1 : n.matcher_type === "template" ? -1 : r.matcher_type === "template" ? 1 : n.matcher_type === "schema" ? -1 : r.matcher_type === "schema" ? 1 : n.matcher_type === "collection" ? -1 : r.matcher_type === "collection" ? 1 : n.matcher_type === "token" ? -1 : r.matcher_type === "token" ? 1 : 0), e;
}, vt = (t) => t.sort((e, n) => e.status === "active" && n.status !== "active" ? -1 : e.status !== "active" && n.status === "active" || e.contract === "blenderizerx" ? 1 : n.contract === "blenderizerx" ? -1 : 0), ze = (t, e = "mint") => t.sort((n, r) => n[e] > r[e] ? -1 : n[e] < r[e] ? 1 : 0), ge = (t, e, n, r = !0) => {
  n.dispatchEvent(
    new CustomEvent(t, {
      detail: e,
      composed: r
      // propagate across the shadow DOM
    })
  );
};
let ot = null;
const On = async ({
  atomic_url: t,
  blend_id: e,
  contract: n,
  chain: r
}) => {
  if (!n)
    return null;
  const { data: l, error: i } = await ue(
    `/neftyblends/v1/blends/${n}/${e}`,
    {
      baseUrl: t,
      params: {
        render_markdown: "true"
      }
    }
  );
  if (i)
    return console.error(i), null;
  if (l) {
    const {
      rolls: o,
      blend_id: s,
      contract: d,
      start_time: c,
      end_time: m,
      ingredients: u,
      ingredients_count: b,
      security_id: _,
      display_data: p,
      category: g,
      collection_name: h,
      use_count: L,
      account_limit: y,
      account_limit_cooldown: T,
      max: C
    } = l.data, N = (/* @__PURE__ */ new Date()).getTime(), M = [], k = {}, I = {};
    for (let ie = 0; ie < u.length; ie++) {
      const {
        template: Q,
        collection: B,
        attributes: j,
        schema: $,
        ft_amount: K,
        type: V,
        amount: ne,
        index: F,
        display_data: te
      } = u[ie];
      let E, H, J, Y, q = 0, R = h;
      if (V === "ATTRIBUTE_INGREDIENT") {
        H = "attributes", E = `${s}|${d}|${F}`, R = j.collection_name;
        let x;
        try {
          x = te ? JSON.parse(te) : null;
        } catch {
          x = { description: te };
        }
        const Z = j.attributes.map(({ name: U, allowed_values: oe }) => {
          const he = oe.join(", ");
          return `${U} equals "${he}"`;
        }).join(" and ");
        k[E] = {
          name: j.collection_name,
          description: (x == null ? void 0 : x.description) || Z,
          matcher_type: H,
          matcher: E,
          market_data: `${j.collection_name}|${j.schema_name}`,
          video: null,
          image: null
        };
      } else if (V === "BALANCE_INGREDIENT") {
        E = `${s}|${d}|${F}|${Q.attribute_name}`, H = "balance", R = Q.collection.collection_name;
        const x = pe(Q), { image: Z, video: U } = we(
          x,
          Q.schema.format
        );
        J = Q.cost, k[E] = {
          name: Q.attribute_name,
          matcher_type: H,
          matcher: E,
          market_data: `${Q.collection.collection_name}|${Q.template_id}`,
          value: J,
          video: U ? ae(U) : null,
          image: Z ? ae(Z) : null
        };
      } else if (V === "SCHEMA_INGREDIENT") {
        E = `${$.c}|${$.s}`, H = "schema", R = $.c;
        let x;
        try {
          x = te ? JSON.parse(te) : null;
        } catch {
          x = { description: te };
        }
        k[E] = {
          name: $.c,
          description: x == null ? void 0 : x.description,
          matcher_type: H,
          matcher: E,
          market_data: `${$.c}|${$.s}`,
          video: null,
          image: null
        };
      } else if (V === "TEMPLATE_INGREDIENT") {
        E = Q.template_id, H = "template", R = Q.collection.collection_name;
        const x = pe(Q), { name: Z } = x, { video: U, image: oe } = we(
          x,
          Q.schema.format
        );
        k[E] = {
          name: Z,
          matcher_type: H,
          matcher: E,
          market_data: `${Q.collection.collection_name}|${Q.template_id}`,
          video: U ? ae(U) : null,
          image: oe ? ae(oe) : null
        };
      } else if (V === "COLLECTION_INGREDIENT") {
        E = B == null ? void 0 : B.collection_name, H = "collection", R = B == null ? void 0 : B.collection_name;
        const {
          data: { img: x }
        } = B;
        k[E] = {
          name: E,
          matcher_type: H,
          matcher: E,
          market_data: B.collection_name,
          video: null,
          image: x ? ae(x) : null
        };
      }
      if (V === "FT_INGREDIENT") {
        if (E = `${K.token_symbol}|${K.token_contract}`, H = "token", !ot) {
          const { data: oe } = await ue(
            `/api/logos/${r}`,
            {
              baseUrl: "https://rates.neftyblocks.com"
            }
          );
          oe && (ot = oe);
        }
        const { token_symbol: x, token_contract: Z } = K, U = ot[`${x}@${Z}`];
        J = sn(K.amount, K.token_precision), Y = {
          ...K,
          value: J
        }, k[E] && (J += k[E].value, Y && (Y.amount += k[E].token.amount, Y.value += k[E].token.value)), k[E] = {
          name: x,
          matcher_type: H,
          matcher: E,
          value: J,
          video: null,
          market_data: null,
          image: U ? ae(U.logo) : null,
          token: Y
        };
      }
      q = ne, I[E] && V !== "FT_INGREDIENT" && (q += I[E].amount), I[E] = {
        key: V,
        collection_name: R,
        amount: q,
        value: J,
        token: Y,
        matcher_type: H,
        matcher: E
      };
    }
    const A = o[0].total_odds, G = o[0].outcomes;
    let ee = !0, re = !1, ce = null;
    for (let ie = 0; ie < G.length; ie++) {
      const { results: Q, odds: B } = G[ie], j = B / A * 100;
      j === 100 && (ee = !1);
      const $ = In(j);
      if (!Q.length)
        M.push({
          name: "empty",
          drop_rate: j,
          rarity: $,
          mint: null,
          empty: !0,
          image: null
        });
      else
        for (let K = 0; K < Q.length; K++) {
          const { template: V, pool: ne } = Q[K];
          if (V) {
            const F = +V.issued_supply, te = +V.max_supply;
            (te === 0 ? !1 : F === te) && (re = !0);
            const H = pe(V), { name: J } = H, { image: Y, video: q } = we(
              H,
              V.schema.format
            );
            M.push({
              name: J,
              drop_rate: j,
              rarity: $,
              matcher_type: "template",
              market_data: `${V.collection.collection_name}|${V.template_id}`,
              mint: {
                amount: +V.issued_supply,
                supply: +V.max_supply == 0 ? "∞" : V.max_supply
              },
              video: q ? ae(q) : null,
              image: Y ? ae(Y) : null
            }), ce || (ce = ae(
              Y,
              300,
              !0
            ));
          } else if (ne) {
            const F = ne.display_data ? JSON.parse(ne.display_data) : null;
            F && M.push({
              name: F.name,
              drop_rate: j,
              rarity: $,
              matcher_type: "pool",
              mint: null,
              video: F.video ? ae(F.video) : null,
              image: F.image ? ae(F.image) : null
            });
          }
        }
    }
    const { blend_name: W } = cn(
      p,
      o[0].outcomes[0].results[0]
    ), le = +C != 0 && +L >= +C;
    return {
      blend_id: s,
      contract: d,
      collection_name: h,
      name: W,
      description: p == null ? void 0 : p.description,
      start_time: c,
      end_time: m,
      items: Object.values(k),
      results: M,
      category: g,
      ingredients_count: b,
      result_count: M.length,
      secure: _ !== "0",
      security_id: _,
      odds: ee,
      requirements: I,
      account_limit: +y,
      account_limit_cooldown: +T,
      count: {
        current: +L,
        max: +C
      },
      status: _e(c, m, N) === "ended" ? "ended" : le ? "sold-out" : re ? "max-reached" : "active",
      backgroundImg: ce
    };
  }
  return null;
}, Dn = async ({
  atomic_url: t,
  collection: e,
  page: n = 1,
  category: r,
  ingredient_match: l,
  ingredient_owner: i
}) => {
  const o = l && i ? { ingredient_match: l, ingredient_owner: i } : {}, { data: s, error: d } = await ue("/neftyblends/v1/blends", {
    baseUrl: t,
    params: {
      collection_name: e,
      visibility: "visible",
      limit: "1000",
      page: `${n}`,
      ...o,
      category: r
    }
  });
  if (d)
    return console.error(d), null;
  if (s) {
    const c = (/* @__PURE__ */ new Date()).getTime(), m = {}, u = {}, b = [];
    for (let _ = 0; _ < s.data.length; _++) {
      const {
        rolls: p,
        blend_id: g,
        contract: h,
        start_time: L,
        end_time: y,
        ingredients: T,
        ingredients_count: C,
        security_id: N,
        display_data: M,
        is_hidden: k,
        category: I,
        max: A,
        use_count: G,
        fulfilled: ee
      } = s.data[_];
      if (k)
        continue;
      let re = !1;
      const ce = [], W = [];
      I && !b.includes(I) && b.push(I);
      for (let K = 0; K < T.length; K++) {
        const { template: V } = T[K];
        if (!V)
          continue;
        const ne = pe(V), { img: F, name: te } = ne;
        ce.push({
          name: te,
          image: ae(F)
        });
      }
      const le = p[0].outcomes;
      for (let K = 0; K < le.length; K++) {
        const { results: V } = le[K];
        if (!V.length)
          W.push({
            name: "empty",
            empty: !0,
            image: null
          });
        else
          for (let ne = 0; ne < V.length; ne++) {
            const { template: F, pool: te } = V[ne];
            if (F) {
              const E = +F.issued_supply, H = +F.max_supply;
              (H === 0 ? !1 : E === H) && (re = !0);
              const Y = pe(F), { img: q, name: R } = Y;
              W.push({
                name: R,
                image: q ? ae(q) : null
              });
            }
            if (te) {
              const E = te.display_data ? JSON.parse(te.display_data) : null;
              E && W.push({
                name: E.name,
                image: E.image ? ae(
                  E.image
                ) : null
              });
            }
          }
      }
      const ie = M ? JSON.parse(M) : null, { blend_img: Q, blend_video: B, blend_name: j } = cn(
        ie,
        p[0].outcomes[0].results[0]
      ), $ = +A != 0 && +G >= +A;
      m[`${h}_${g}`] = {
        blend_id: g,
        contract: h,
        name: j,
        start_time: L,
        end_time: y,
        items: ce,
        fulfilled: ee,
        results: W,
        category: I,
        ingredients_count: C,
        result_count: W.length,
        secure: N !== "0",
        display_data: ie,
        status: _e(L, y, c) === "ended" ? "ended" : $ ? "sold-out" : re ? "max-reached" : "active",
        image: Q ? ae(Q) : null,
        video: B ? ae(B) : null
      }, u[`${j}_${W.map((K) => K.schema_name).join("_")}`] = `${h}_${g}`;
    }
    return { content: m, search: u, categories: b };
  }
  return null;
}, ut = {
  is_transferable: "true",
  is_burnable: "true",
  order: "desc",
  sort: "template_mint",
  limit: "1000",
  page: "1"
}, un = {
  order: "desc",
  sort: "asset_id"
}, Ye = (t) => {
  if (t.length > 0) {
    const n = [];
    for (let r = 0; r < t.length; r++) {
      const { amount: l, token_precision: i, token_symbol: o } = t[r];
      n.push(
        `${We(
          sn(l, i),
          i
        )} ${o}`
      );
    }
    return n.join(", ");
  }
  return null;
}, Bn = async ({
  blend_id: t,
  contract: e,
  index: n,
  atomic_url: r,
  actor: l,
  matcher: i
}) => {
  const o = {
    type: "attributes",
    data: {}
  }, { data: s, error: d } = await ue(
    `/neftyblends/v1/blends/${e}/${t}/ingredients/${n}/assets`,
    {
      baseUrl: r,
      params: {
        owner: l,
        ...un
      }
    }
  );
  if (d && console.error(d), s) {
    const { data: c } = s;
    if (c.length) {
      const m = [], u = [];
      for (let b = 0; b < c.length; b++) {
        const { asset_id: _, template_mint: p, backed_tokens: g } = c[b], h = pe(c[b]), { name: L } = h, { image: y, video: T } = we(
          h,
          c[b].schema.format
        ), C = Ye(g), N = Ue(h), M = {
          asset_id: _,
          name: L,
          rarity: N,
          mint: +p,
          video: T ? ae(T) : null,
          image: y ? ae(y) : null,
          backedByTokens: C
        };
        C ? u.push(M) : m.push(M);
      }
      o.data[i] = [
        ...ze(m),
        ...ze(u)
      ];
    }
  }
  return o;
}, qn = async ({
  blend_id: t,
  contract: e,
  index: n,
  atomic_url: r,
  actor: l,
  matcher: i,
  attribute_name: o
}) => {
  const s = {
    type: "balance",
    data: {}
  }, { data: d, error: c } = await ue(
    `/neftyblends/v1/blends/${e}/${t}/ingredients/${n}/assets`,
    {
      baseUrl: r,
      params: {
        owner: l,
        ...un
      }
    }
  );
  if (c && console.error(c), d) {
    const { data: m } = d;
    if (m.length) {
      const u = [], b = [];
      for (let _ = 0; _ < m.length; _++) {
        const { asset_id: p, template_mint: g, mutable_data: h, backed_tokens: L } = m[_], y = Ye(L), T = {
          asset_id: p,
          name: o,
          mint: +g,
          value: +h[o],
          backedByTokens: y
        };
        y ? b.push(T) : u.push(T);
      }
      s.data[i] = [
        ...ze(u, "value"),
        ...ze(b, "value")
      ];
    }
  }
  return s;
}, Hn = async ({
  collection_name: t,
  atomic_url: e,
  schema_name: n,
  actor: r,
  matcher: l
}) => {
  const i = {
    type: "schema",
    data: {}
  }, { data: o, error: s } = await ue("/atomicassets/v1/assets", {
    baseUrl: e,
    params: {
      collection_name: t,
      schema_name: n,
      owner: r,
      ...ut
    }
  });
  if (s && console.error(s), o) {
    const { data: d } = o;
    if (d.length) {
      const c = [], m = [];
      for (let u = 0; u < d.length; u++) {
        const { asset_id: b, template_mint: _, backed_tokens: p } = d[u], g = pe(d[u]), { name: h } = g, { image: L, video: y } = we(
          g,
          d[u].schema.format
        ), T = Ye(p), C = Ue(g), N = {
          asset_id: b,
          name: h,
          rarity: C,
          mint: +_,
          video: y ? ae(y) : null,
          image: L ? ae(L) : null,
          backedByTokens: T
        };
        T ? m.push(N) : c.push(N);
      }
      i.data[l] = [
        ...ze(c),
        ...ze(m)
      ];
    }
  }
  return i;
}, $n = async ({
  template_id: t,
  collection_name: e,
  atomic_url: n,
  actor: r
}) => {
  const l = {
    type: "template",
    data: {}
  }, { data: i, error: o } = await ue("/atomicassets/v1/assets", {
    baseUrl: n,
    params: {
      collection_name: e,
      template_id: t,
      owner: r,
      ...ut
    }
  });
  if (o && console.error(o), i) {
    const { data: s } = i;
    if (s.length) {
      const d = [], c = [];
      for (let m = 0; m < s.length; m++) {
        const { asset_id: u, template_mint: b, backed_tokens: _ } = s[m], p = Ye(_), g = pe(s[m]), h = Ue(g), L = {
          asset_id: u,
          rarity: h,
          mint: +b,
          backedByTokens: p
        };
        p ? c.push(L) : d.push(L);
      }
      l.data[t] = [
        ...ze(d),
        ...ze(c)
      ];
    }
  }
  return l;
}, Gn = async ({
  collection_name: t,
  atomic_url: e,
  actor: n
}) => {
  const r = {
    type: "collection",
    data: {}
  }, { data: l, error: i } = await ue("/atomicassets/v1/assets", {
    baseUrl: e,
    params: {
      collection_name: t,
      owner: n,
      ...ut
    }
  });
  if (i && console.error(i), l) {
    const { data: o } = l;
    if (o.length) {
      const s = [], d = [];
      for (let c = 0; c < o.length; c++) {
        const { asset_id: m, template_mint: u, backed_tokens: b } = o[c], _ = pe(o[c]), { name: p } = _, { image: g, video: h } = we(
          _,
          o[c].schema.format
        ), L = Ye(b), y = Ue(_), T = {
          asset_id: m,
          name: p,
          rarity: y,
          mint: +u,
          video: h ? ae(h) : null,
          image: g ? ae(g) : null,
          backedByTokens: L
        };
        L ? d.push(T) : s.push(T);
      }
      r.data[t] = [...s, ...d];
    }
  }
  return r;
}, Rn = async ({
  chain_url: t,
  actor: e,
  code: n,
  symbol: r,
  matcher: l
}) => {
  const i = {
    type: "token",
    data: {}
  }, { data: o, error: s } = await ue(
    "/v1/chain/get_currency_balance",
    {
      baseUrl: t,
      method: "POST",
      body: {
        code: n,
        symbol: r,
        account: e
      }
    }
  );
  return s && console.error(s), o && (i.data[l] = o[0]), i;
}, Un = async ({
  requirements: t,
  atomic_url: e,
  chain_url: n,
  actor: r
}) => {
  const l = [];
  let i = {};
  const o = Object.values(t);
  for (let d = 0; d < o.length; d++) {
    const c = o[d];
    if (c.key === "ATTRIBUTE_INGREDIENT") {
      const [m, u, b] = c.matcher.split("|");
      l.push(
        Bn({
          blend_id: m,
          contract: u,
          index: b,
          actor: r,
          atomic_url: e,
          matcher: c.matcher
        })
      );
    } else if (c.key === "BALANCE_INGREDIENT") {
      const [m, u, b, _] = c.matcher.split("|");
      l.push(
        qn({
          blend_id: m,
          contract: u,
          index: b,
          actor: r,
          atomic_url: e,
          matcher: c.matcher,
          attribute_name: _
        })
      );
    } else if (c.key === "SCHEMA_INGREDIENT") {
      const [, m] = c.matcher.split("|");
      l.push(
        Hn({
          schema_name: m,
          collection_name: c.collection_name,
          actor: r,
          atomic_url: e,
          matcher: c.matcher
        })
      );
    } else if (c.key === "TEMPLATE_INGREDIENT")
      l.push(
        $n({
          template_id: c.matcher,
          collection_name: c.collection_name,
          actor: r,
          atomic_url: e
        })
      );
    else if (c.key === "COLLECTION_INGREDIENT")
      l.push(
        Gn({
          collection_name: c.matcher,
          actor: r,
          atomic_url: e
        })
      );
    else if (c.key === "FT_INGREDIENT") {
      const m = c.matcher.split("|");
      l.push(
        Rn({
          chain_url: n,
          actor: r,
          code: m[1],
          symbol: m[0],
          matcher: c.matcher
        })
      );
    }
  }
  const s = await Promise.allSettled(l);
  for (let d = 0; d < s.length; d++) {
    const c = s[d];
    c.status === "fulfilled" && (i = { ...c.value.data, ...i });
  }
  return i;
}, Yn = async ({ contract: t, blend_id: e, tx_id: n, atomic_url: r }) => {
  var s;
  const l = [], { data: i, error: o } = await Cn({
    retries: 3,
    delay: 1500,
    retryOn: (d) => d.success === !1 || d.data.length === 0,
    call: () => ue(
      `/neftyblends/v1/blends/${t}/${e}/claims`,
      {
        baseUrl: r,
        params: {
          tx_id: n
        }
      }
    )
  });
  if (o && console.error(o), (s = i == null ? void 0 : i.data) != null && s.length) {
    const d = i.data[0].results;
    if (!d.length)
      l.push({
        name: "empty",
        rarity: null,
        mint: null,
        empty: !0,
        image: null
      });
    else
      for (let c = 0; c < d.length; c++) {
        const { template: m, asset: u } = d[c], b = pe(m || u), { name: _ } = b, { image: p, video: g } = we(
          b,
          (m == null ? void 0 : m.schema.format) || void 0
        ), h = Ue(b), L = u ? {
          amount: +u.template_mint,
          supply: +u.template.max_supply == 0 ? "∞" : u.template.max_supply
        } : null;
        l.push({
          name: _,
          mint: L,
          rarity: h,
          video: g ? ae(g) : null,
          image: p ? ae(p) : null
        });
      }
  }
  return l;
}, Pn = async ({ chain_url: t }) => {
  const { data: e, error: n } = await ue(
    "/v1/chain/get_table_by_scope",
    {
      baseUrl: t,
      method: "POST",
      body: {
        code: "orng.wax",
        table: "jobs.a",
        reverse: !1,
        limit: 100,
        show_payer: !1
      }
    }
  );
  return n && console.error(n), e ? e.rows.length : 0;
}, Vn = async ({
  chain_url: t,
  actor: e,
  security_id: n,
  atomic_url: r,
  collection: l
}) => {
  const i = {
    allowed: !1,
    result: [],
    reason: ""
  }, [o, s] = await Promise.allSettled([
    ue("/v1/chain/get_table_rows", {
      baseUrl: t,
      method: "POST",
      body: {
        code: "secure.nefty",
        scope: n,
        table: "whitelists",
        lower_bound: e,
        upper_bound: e,
        limit: 1,
        json: !0
      }
    }),
    ue("/v1/chain/get_table_rows", {
      baseUrl: t,
      method: "POST",
      body: {
        code: "secure.nefty",
        scope: l,
        table: "proofown",
        limit: 1,
        lower_bound: n,
        upper_bound: n,
        json: !0
      }
    })
  ]);
  if (o.status === "fulfilled") {
    const { data: d } = o.value;
    if (d.rows.length > 0)
      for (let c = 0; c < d.rows.length; c++) {
        const { account: m } = d.rows[c];
        if (m === e) {
          i.allowed = !0, i.result = [
            "WHITELIST_CHECK",
            {
              account_name: e
            }
          ];
          break;
        } else
          i.reason = "not whitelisted";
      }
    else
      i.reason = "whitelist not found";
  }
  if (s.status === "fulfilled") {
    const { data: d } = s.value, c = await Zn(d, e, r, t);
    if (c) {
      const { validtokens: m, missingAssets: u, validAssets: b, reason: _ } = c, p = m && !u;
      i.allowed = p, p ? i.result = [
        "OWNERSHIP_CHECK",
        {
          account_name: e,
          asset_ids: b
        }
      ] : i.reason = jn[_];
    } else
      i.reason = "proof of ownership failed";
  }
  return i;
}, Jn = async ({
  chain_url: t,
  actor: e,
  blend_id: n,
  account_limit: r,
  account_limit_cooldown: l
}) => {
  const i = {
    allowed: !0,
    wait: 0,
    left: r,
    reason: ""
  }, { data: o, error: s } = await ue("/v1/chain/get_table_rows", {
    baseUrl: t,
    method: "POST",
    body: {
      code: "blend.nefty",
      table: "accstats",
      scope: n,
      limit: "1",
      key_type: "",
      lower_bound: e,
      upper_bound: e,
      index_position: 1,
      show_payer: !1,
      reverse: !1,
      json: !0
    }
  });
  if (s && console.error(s), o != null && o.rows.length) {
    const d = (/* @__PURE__ */ new Date()).getTime(), { counter: c, last_claim_time: m } = o.rows[0];
    if (l === 0) {
      const u = r - c;
      u <= 0 && (i.allowed = !1, i.reason = "limit reached."), i.left = u;
    } else {
      const u = r - c, b = new Date(m * 1e3).getTime(), _ = d - b, p = Math.floor(_ / 1e3), g = l - p;
      i.wait = g >= 0 ? g : 0, u <= 0 ? g >= 0 && (i.allowed = !1, i.reason = "wait for cooldown") : i.left = g >= 0 ? u : r;
    }
  }
  return i;
};
async function Zn(t, e, n, r) {
  const { rows: l } = t;
  let i = [], o = !0, s = !1, d = "";
  if (l.length) {
    const {
      group: { filters: c, logical_operator: m }
    } = l[0];
    for (let u = 0; u < c.length; u++) {
      const [b, _] = c[u];
      if (b === "TOKEN_HOLDING") {
        const p = await Wn({
          value: _,
          actor: e,
          chain_url: r
        });
        if (+m == 1) {
          if (o = p, p === !0) {
            o = !0;
            break;
          }
        } else if (o = p, p === !1) {
          o = !1, d = b;
          break;
        }
      } else {
        const p = await Fn({
          key: b,
          value: _,
          actor: e,
          atomic_url: n
        });
        if (p.length) {
          if (i.push(...p), +m == 1) {
            s = !1;
            break;
          }
        } else
          s = !0, d = b;
      }
    }
    return i = s ? [] : [...new Set(i)], {
      logical_operator: m,
      validtokens: o,
      missingAssets: s,
      validAssets: i,
      reason: d
    };
  }
  return null;
}
async function Wn({ value: t, chain_url: e, actor: n }) {
  const [r, l] = t.amount.split(" "), { data: i, error: o } = await ue(
    "/v1/chain/get_currency_balance",
    {
      baseUrl: e,
      method: "POST",
      body: {
        code: t.token_contract,
        symbol: l,
        account: n
      }
    }
  );
  if (o && console.error(o), i)
    for (let s = 0; s < i.length; s++) {
      const [d, c] = i[s].split(" ");
      if (c === l)
        return fn[+t.comparison_operator](
          +d,
          +r
        );
    }
  return !1;
}
async function Fn({
  key: t,
  value: e,
  actor: n,
  atomic_url: r
}) {
  const {
    collection_name: l,
    template_id: i,
    schema_name: o,
    comparison_operator: s,
    amount: d
  } = e, c = [], m = `${+d + 1}`, _ = await An({
    TEMPLATE_HOLDINGS: async () => {
      const { data: p, error: g } = await ue(
        "/atomicassets/v1/assets",
        {
          baseUrl: r,
          method: "GET",
          params: {
            owner: n,
            collection_name: l,
            template_id: i,
            limit: m
          }
        }
      );
      return g ? [] : p.data;
    },
    COLLECTION_HOLDINGS: async () => {
      const { data: p, error: g } = await ue(
        "/atomicassets/v1/assets",
        {
          baseUrl: r,
          method: "GET",
          params: {
            owner: n,
            collection_name: l,
            limit: m
          }
        }
      );
      return g ? [] : p.data;
    },
    SCHEMA_HOLDINGS: async () => {
      const { data: p, error: g } = await ue(
        "/atomicassets/v1/assets",
        {
          baseUrl: r,
          method: "GET",
          params: {
            owner: n,
            collection_name: l,
            schema_name: o,
            limit: m
          }
        }
      );
      return g ? [] : p.data;
    },
    _default: async () => Promise.resolve([])
  }, "_default")(t);
  for (let p = 0; p < _.length; p++) {
    const { asset_id: g } = _[p];
    c.push(g);
  }
  return fn[+s](c.length, +d) ? c : [];
}
const be = rt({
  account: null,
  blend: null,
  config: null,
  transactionId: null
}), Ke = rt([]), Oe = rt(!1), et = rt("");
function yt(t, e, n) {
  const r = t.slice();
  return r[31] = e[n], r;
}
function kt(t, e, n) {
  const r = t.slice();
  return r[34] = e[n], r;
}
function wt(t) {
  let e, n, r, l, i, o, s;
  return {
    c() {
      e = v("select"), n = v("option"), n.textContent = "Show all", r = v("option"), r.textContent = "Own all requirements", l = v("option"), l.textContent = "Missing one requirement", i = v("option"), i.textContent = "Own at least one requirement", n.__value = "", n.value = n.__value, r.__value = "all", r.value = r.__value, l.__value = "missing_x", l.value = l.__value, i.__value = "any", i.value = i.__value, /*$requirments*/
      t[8] === void 0 && Be(() => (
        /*select_change_handler*/
        t[16].call(e)
      ));
    },
    m(d, c) {
      w(d, e, c), f(e, n), f(e, r), f(e, l), f(e, i), Ze(
        e,
        /*$requirments*/
        t[8],
        !0
      ), o || (s = [
        se(
          e,
          "change",
          /*select_change_handler*/
          t[16]
        ),
        se(
          e,
          "input",
          /*selectUpdate*/
          t[11]
        )
      ], o = !0);
    },
    p(d, c) {
      c[0] & /*$requirments*/
      256 && Ze(
        e,
        /*$requirments*/
        d[8]
      );
    },
    d(d) {
      d && z(e), o = !1, ve(s);
    }
  };
}
function zt(t) {
  let e, n, r, l, i = (
    /*$categories*/
    t[7]
  ), o = [];
  for (let s = 0; s < i.length; s += 1)
    o[s] = Tt(kt(t, i, s));
  return {
    c() {
      e = v("select"), n = v("option"), n.textContent = "No category";
      for (let s = 0; s < o.length; s += 1)
        o[s].c();
      n.__value = "", n.value = n.__value, /*selectedCategory*/
      t[3] === void 0 && Be(() => (
        /*select_change_handler_1*/
        t[17].call(e)
      ));
    },
    m(s, d) {
      w(s, e, d), f(e, n);
      for (let c = 0; c < o.length; c += 1)
        o[c] && o[c].m(e, null);
      Ze(
        e,
        /*selectedCategory*/
        t[3],
        !0
      ), r || (l = [
        se(
          e,
          "change",
          /*select_change_handler_1*/
          t[17]
        ),
        se(
          e,
          "input",
          /*selectUpdate*/
          t[11]
        )
      ], r = !0);
    },
    p(s, d) {
      if (d[0] & /*$categories*/
      128) {
        i = /*$categories*/
        s[7];
        let c;
        for (c = 0; c < i.length; c += 1) {
          const m = kt(s, i, c);
          o[c] ? o[c].p(m, d) : (o[c] = Tt(m), o[c].c(), o[c].m(e, null));
        }
        for (; c < o.length; c += 1)
          o[c].d(1);
        o.length = i.length;
      }
      d[0] & /*selectedCategory, $categories*/
      136 && Ze(
        e,
        /*selectedCategory*/
        s[3]
      );
    },
    d(s) {
      s && z(e), He(o, s), r = !1, ve(l);
    }
  };
}
function Tt(t) {
  let e, n = (
    /*category*/
    t[34] + ""
  ), r, l;
  return {
    c() {
      e = v("option"), r = O(n), e.__value = l = /*category*/
      t[34], e.value = e.__value;
    },
    m(i, o) {
      w(i, e, o), f(e, r);
    },
    p(i, o) {
      o[0] & /*$categories*/
      128 && n !== (n = /*category*/
      i[34] + "") && P(r, n), o[0] & /*$categories*/
      128 && l !== (l = /*category*/
      i[34]) && (e.__value = l, e.value = e.__value);
    },
    d(i) {
      i && z(e);
    }
  };
}
function Xn(t) {
  let e;
  return {
    c() {
      e = v("p"), e.innerHTML = `<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#blender"></use></svg>
        loading blends...`, a(e, "class", "loading");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function Qn(t) {
  let e;
  return {
    c() {
      e = v("p"), e.innerHTML = `<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#blender"></use></svg>
        Whoops someone spilled the juice!`, a(e, "class", "error");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function Kn(t) {
  let e, n, r, l, i, o, s, d, c, m, u = (
    /*lastPageReached*/
    (t[5] ? (
      /*currentPage*/
      t[4]
    ) : "∞") + ""
  ), b, _, p, g, h, L, y;
  function T(M, k) {
    return (
      /*data*/
      M[0].length ? tr : er
    );
  }
  let C = T(t), N = C(t);
  return {
    c() {
      N.c(), e = D(), n = v("nav"), r = v("button"), l = S("svg"), i = S("use"), s = D(), d = v("p"), c = O(
        /*currentPage*/
        t[4]
      ), m = O(" / "), b = O(u), _ = D(), p = v("button"), g = S("svg"), h = S("use"), Ne(i, "xlink:href", "#arrow_left"), a(l, "role", "presentation"), a(l, "focusable", "false"), a(l, "aria-hidden", "true"), a(r, "class", "btn-clear"), r.disabled = o = /*currentPage*/
      t[4] === 1, Ne(h, "xlink:href", "#arrow_right"), a(g, "role", "presentation"), a(g, "focusable", "false"), a(g, "aria-hidden", "true"), a(p, "class", "btn-clear"), p.disabled = /*lastPageReached*/
      t[5], a(n, "class", "pagination");
    },
    m(M, k) {
      N.m(M, k), w(M, e, k), w(M, n, k), f(n, r), f(r, l), f(l, i), f(n, s), f(n, d), f(d, c), f(d, m), f(d, b), f(n, _), f(n, p), f(p, g), f(g, h), L || (y = [
        se(
          r,
          "click",
          /*click_handler_1*/
          t[19]
        ),
        se(
          p,
          "click",
          /*click_handler_2*/
          t[20]
        )
      ], L = !0);
    },
    p(M, k) {
      C === (C = T(M)) && N ? N.p(M, k) : (N.d(1), N = C(M), N && (N.c(), N.m(e.parentNode, e))), k[0] & /*currentPage*/
      16 && o !== (o = /*currentPage*/
      M[4] === 1) && (r.disabled = o), k[0] & /*currentPage*/
      16 && P(
        c,
        /*currentPage*/
        M[4]
      ), k[0] & /*lastPageReached, currentPage*/
      48 && u !== (u = /*lastPageReached*/
      (M[5] ? (
        /*currentPage*/
        M[4]
      ) : "∞") + "") && P(b, u), k[0] & /*lastPageReached*/
      32 && (p.disabled = /*lastPageReached*/
      M[5]);
    },
    d(M) {
      N.d(M), M && z(e), M && z(n), L = !1, ve(y);
    }
  };
}
function er(t) {
  let e;
  return {
    c() {
      e = v("p"), e.innerHTML = `<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#blender"></use></svg>
            No results found`, a(e, "class", "error");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function tr(t) {
  let e, n = (
    /*data*/
    t[0]
  ), r = [];
  for (let l = 0; l < n.length; l += 1)
    r[l] = Ct(yt(t, n, l));
  return {
    c() {
      e = v("div");
      for (let l = 0; l < r.length; l += 1)
        r[l].c();
      a(e, "class", "blends-group");
    },
    m(l, i) {
      w(l, e, i);
      for (let o = 0; o < r.length; o += 1)
        r[o] && r[o].m(e, null);
    },
    p(l, i) {
      if (i[0] & /*data, blendUrl, viewBlend, now*/
      8707) {
        n = /*data*/
        l[0];
        let o;
        for (o = 0; o < n.length; o += 1) {
          const s = yt(l, n, o);
          r[o] ? r[o].p(s, i) : (r[o] = Ct(s), r[o].c(), r[o].m(e, null));
        }
        for (; o < r.length; o += 1)
          r[o].d(1);
        r.length = n.length;
      }
    },
    d(l) {
      l && z(e), He(r, l);
    }
  };
}
function Mt(t) {
  let e, n;
  return {
    c() {
      e = S("svg"), n = S("use"), a(n, "href", "#clock");
    },
    m(r, l) {
      w(r, e, l), f(e, n);
    },
    d(r) {
      r && z(e);
    }
  };
}
function nr(t) {
  let e;
  return {
    c() {
      e = v("small"), e.textContent = "empty";
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function rr(t) {
  let e, n, r, l, i, o, s;
  return {
    c() {
      e = v("img"), l = D(), i = v("img"), a(e, "class", "shadow"), de(e.src, n = /*blend*/
      t[31].image) || a(e, "src", n), a(e, "alt", r = /*blend*/
      t[31].name), a(e, "loading", "lazy"), de(i.src, o = /*blend*/
      t[31].image) || a(i, "src", o), a(i, "alt", s = /*blend*/
      t[31].name), a(i, "loading", "lazy");
    },
    m(d, c) {
      w(d, e, c), w(d, l, c), w(d, i, c);
    },
    p(d, c) {
      c[0] & /*data*/
      1 && !de(e.src, n = /*blend*/
      d[31].image) && a(e, "src", n), c[0] & /*data*/
      1 && r !== (r = /*blend*/
      d[31].name) && a(e, "alt", r), c[0] & /*data*/
      1 && !de(i.src, o = /*blend*/
      d[31].image) && a(i, "src", o), c[0] & /*data*/
      1 && s !== (s = /*blend*/
      d[31].name) && a(i, "alt", s);
    },
    d(d) {
      d && z(e), d && z(l), d && z(i);
    }
  };
}
function lr(t) {
  let e, n;
  return {
    c() {
      e = v("video"), de(e.src, n = /*blend*/
      t[31].video) || a(e, "src", n), e.loop = !0, e.autoplay = !0, e.muted = !0, e.playsInline = !0;
    },
    m(r, l) {
      w(r, e, l);
    },
    p(r, l) {
      l[0] & /*data*/
      1 && !de(e.src, n = /*blend*/
      r[31].video) && a(e, "src", n);
    },
    d(r) {
      r && z(e);
    }
  };
}
function Nt(t) {
  let e, n;
  return {
    c() {
      e = S("svg"), n = S("use"), a(n, "href", "#lock");
    },
    m(r, l) {
      w(r, e, l), f(e, n);
    },
    d(r) {
      r && z(e);
    }
  };
}
function Lt(t) {
  let e, n, r = (
    /*blend*/
    t[31].fulfilled + ""
  ), l, i, o = (
    /*blend*/
    t[31].ingredients_count + ""
  ), s, d;
  return {
    c() {
      e = v("small"), n = O("Holding "), l = O(r), i = O(" / "), s = O(o), d = O(`
                            ingredients`), a(e, "class", "fulfilled");
    },
    m(c, m) {
      w(c, e, m), f(e, n), f(e, l), f(e, i), f(e, s), f(e, d);
    },
    p(c, m) {
      m[0] & /*data*/
      1 && r !== (r = /*blend*/
      c[31].fulfilled + "") && P(l, r), m[0] & /*data*/
      1 && o !== (o = /*blend*/
      c[31].ingredients_count + "") && P(s, o);
    },
    d(c) {
      c && z(e);
    }
  };
}
function Ct(t) {
  let e, n, r = !["ended", "live"].includes(_e(
    /*blend*/
    t[31].start_time,
    /*blend*/
    t[31].end_time,
    /*now*/
    t[1]
  )), l, i = (["active", "ended"].includes(
    /*blend*/
    t[31].status
  ) ? _e(
    /*blend*/
    t[31].start_time,
    /*blend*/
    t[31].end_time,
    /*now*/
    t[1]
  ) : ke(
    /*blend*/
    t[31].status
  )) + "", o, s, d, c, m, u, b, _, p, g, h, L, y, T = (
    /*blend*/
    t[31].ingredients_count + ""
  ), C, N, M, k, I, A, G, ee, re, ce = (
    /*blend*/
    t[31].result_count + ""
  ), W, le, ie, Q, B = (
    /*blend*/
    t[31].name + ""
  ), j, $, K, V, ne, F, te, E = r && Mt();
  function H(Z, U) {
    return (
      /*blend*/
      Z[31].video ? lr : (
        /*blend*/
        Z[31].image ? rr : nr
      )
    );
  }
  let J = H(t), Y = J(t), q = (
    /*blend*/
    t[31].secure && Nt()
  ), R = (
    /*blend*/
    t[31].fulfilled && Lt(t)
  );
  function x() {
    return (
      /*click_handler*/
      t[18](
        /*blend*/
        t[31]
      )
    );
  }
  return {
    c() {
      e = v("a"), n = v("time"), E && E.c(), l = D(), o = O(i), d = D(), c = v("figure"), Y.c(), m = D(), u = v("div"), b = v("div"), _ = v("small"), _.textContent = "ingredients", p = D(), g = v("span"), h = S("svg"), L = S("use"), y = D(), C = O(T), N = D(), M = v("div"), k = v("small"), k.textContent = "results", I = D(), A = v("span"), G = S("svg"), ee = S("use"), re = D(), W = O(ce), le = D(), ie = v("h3"), q && q.c(), Q = D(), j = O(B), $ = D(), R && R.c(), K = D(), a(n, "class", s = ke(
        /*blend*/
        t[31].status
      )), a(L, "href", "#hat"), a(b, "class", "stat"), a(ee, "href", "#star"), a(M, "class", "stat"), a(u, "class", "stats"), a(c, "class", "visual"), a(e, "class", V = `btn-clear blends-item ${/*blend*/
      t[31].secure ? "secure" : ""}`), a(e, "href", ne = /*blendUrl*/
      t[13](
        /*blend*/
        t[31]
      ));
    },
    m(Z, U) {
      w(Z, e, U), f(e, n), E && E.m(n, null), f(n, l), f(n, o), f(e, d), f(e, c), Y.m(c, null), f(c, m), f(c, u), f(u, b), f(b, _), f(b, p), f(b, g), f(g, h), f(h, L), f(g, y), f(g, C), f(u, N), f(u, M), f(M, k), f(M, I), f(M, A), f(A, G), f(G, ee), f(A, re), f(A, W), f(e, le), f(e, ie), q && q.m(ie, null), f(ie, Q), f(ie, j), f(e, $), R && R.m(e, null), f(e, K), F || (te = se(e, "click", pn(x)), F = !0);
    },
    p(Z, U) {
      t = Z, U[0] & /*data, now*/
      3 && (r = !["ended", "live"].includes(_e(
        /*blend*/
        t[31].start_time,
        /*blend*/
        t[31].end_time,
        /*now*/
        t[1]
      ))), r ? E || (E = Mt(), E.c(), E.m(n, l)) : E && (E.d(1), E = null), U[0] & /*data, now*/
      3 && i !== (i = (["active", "ended"].includes(
        /*blend*/
        t[31].status
      ) ? _e(
        /*blend*/
        t[31].start_time,
        /*blend*/
        t[31].end_time,
        /*now*/
        t[1]
      ) : ke(
        /*blend*/
        t[31].status
      )) + "") && P(o, i), U[0] & /*data*/
      1 && s !== (s = ke(
        /*blend*/
        t[31].status
      )) && a(n, "class", s), J === (J = H(t)) && Y ? Y.p(t, U) : (Y.d(1), Y = J(t), Y && (Y.c(), Y.m(c, m))), U[0] & /*data*/
      1 && T !== (T = /*blend*/
      t[31].ingredients_count + "") && P(C, T), U[0] & /*data*/
      1 && ce !== (ce = /*blend*/
      t[31].result_count + "") && P(W, ce), /*blend*/
      t[31].secure ? q || (q = Nt(), q.c(), q.m(ie, Q)) : q && (q.d(1), q = null), U[0] & /*data*/
      1 && B !== (B = /*blend*/
      t[31].name + "") && P(j, B), /*blend*/
      t[31].fulfilled ? R ? R.p(t, U) : (R = Lt(t), R.c(), R.m(e, K)) : R && (R.d(1), R = null), U[0] & /*data*/
      1 && V !== (V = `btn-clear blends-item ${/*blend*/
      t[31].secure ? "secure" : ""}`) && a(e, "class", V), U[0] & /*data*/
      1 && ne !== (ne = /*blendUrl*/
      t[13](
        /*blend*/
        t[31]
      )) && a(e, "href", ne);
    },
    d(Z) {
      Z && z(e), E && E.d(), Y.d(), q && q.d(), R && R.d(), F = !1, te();
    }
  };
}
function ir(t) {
  let e, n, r, l, i, o, s, d, c, m, u, b, _, p, g, h, L, y, T, C, N, M, k, I, A, G, ee, re, ce, W = (
    /*$show_owner_filter*/
    t[6] && wt(t)
  ), le = (
    /*$categories*/
    t[7].length && zt(t)
  );
  function ie(j, $) {
    return (
      /*data*/
      j[0] ? Kn : (
        /*data*/
        j[0] === null ? Qn : Xn
      )
    );
  }
  let Q = ie(t), B = Q(t);
  return {
    c() {
      e = S("svg"), n = S("symbol"), r = S("path"), l = S("symbol"), i = S("circle"), o = S("polyline"), s = S("symbol"), d = S("path"), c = S("line"), m = S("symbol"), u = S("polygon"), b = S("symbol"), _ = S("rect"), p = S("path"), g = S("symbol"), h = S("line"), L = S("polyline"), y = S("symbol"), T = S("line"), C = S("polyline"), N = D(), M = v("div"), k = v("input"), I = D(), W && W.c(), A = D(), le && le.c(), G = D(), B.c(), ee = Ie(), this.c = X, a(r, "fill-rule", "nonzero"), a(r, "d", "M15 44c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1v-2a8.8 8.8 0 0 1 4.4-7.6l-2-10H9c-.8 0-1.5-.3-2.1-1-.6-.5-.9-1.2-.9-2V9.5c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h27l-4.4 24.9c1.4 1 2.5 2 3.3 3.4A7.4 7.4 0 0 1 36 39v2c0 .8-.3 1.5-.9 2.1-.6.6-1.3.9-2.1.9H15Zm-1.2-25.6L12 9.5H9v8.8l4.8.1Zm5.3 11.1h9.8l3.5-20H15.1l4 20ZM15 41h18v-2c0-1.8-.7-3.3-2-4.6a7 7 0 0 0-5-1.9h-4c-2 0-3.7.7-5 2a6.2 6.2 0 0 0-2 4.5v2Z"), a(n, "id", "blender"), a(n, "xml:space", "preserve"), a(n, "fill-rule", "evenodd"), a(n, "fill", "currentColor"), a(n, "stroke-linejoin", "round"), a(n, "stroke-miterlimit", "2"), a(n, "clip-rule", "evenodd"), a(n, "viewBox", "0 0 48 48"), a(i, "cx", "12"), a(i, "cy", "12"), a(i, "r", "10"), a(o, "points", "12 6 12 12 16 14"), a(l, "id", "clock"), a(l, "viewBox", "0 0 24 24"), a(l, "fill", "none"), a(l, "stroke", "currentColor"), a(l, "stroke-width", "2"), a(l, "stroke-linecap", "round"), a(l, "stroke-linejoin", "round"), a(d, "d", "M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z"), a(c, "x1", "6"), a(c, "y1", "17"), a(c, "x2", "18"), a(c, "y2", "17"), a(s, "id", "hat"), a(s, "viewBox", "0 0 24 24"), a(s, "fill", "none"), a(s, "stroke", "currentColor"), a(s, "stroke-width", "2"), a(s, "stroke-linecap", "round"), a(s, "stroke-linejoin", "round"), a(u, "points", "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"), a(m, "id", "star"), a(m, "viewBox", "0 0 24 24"), a(m, "fill", "none"), a(m, "stroke", "currentColor"), a(m, "stroke-width", "2"), a(m, "stroke-linecap", "round"), a(m, "stroke-linejoin", "round"), a(_, "x", "3"), a(_, "y", "11"), a(_, "width", "18"), a(_, "height", "11"), a(_, "rx", "2"), a(_, "ry", "2"), a(p, "d", "M7 11V7a5 5 0 0 1 10 0v4"), a(b, "id", "lock"), a(b, "viewBox", "0 0 24 24"), a(b, "fill", "none"), a(b, "stroke", "currentColor"), a(b, "stroke-width", "2"), a(b, "stroke-linecap", "round"), a(b, "stroke-linejoin", "round"), a(h, "x1", "5"), a(h, "y1", "12"), a(h, "x2", "19"), a(h, "y2", "12"), a(L, "points", "12 5 19 12 12 19"), a(g, "id", "arrow_right"), a(g, "viewBox", "0 0 24 24"), a(g, "fill", "none"), a(g, "stroke", "currentColor"), a(g, "stroke-width", "2"), a(g, "stroke-linecap", "round"), a(g, "stroke-linejoin", "round"), a(T, "x1", "19"), a(T, "y1", "12"), a(T, "x2", "5"), a(T, "y2", "12"), a(C, "points", "12 19 5 12 12 5"), a(y, "id", "arrow_left"), a(y, "viewBox", "0 0 24 24"), a(y, "fill", "none"), a(y, "stroke", "currentColor"), a(y, "stroke-width", "2"), a(y, "stroke-linecap", "round"), a(y, "stroke-linejoin", "round"), a(e, "aria-hidden", "true"), a(e, "xmlns", "http://www.w3.org/2000/svg"), a(e, "width", "0"), a(e, "height", "0"), $e(e, "position", "absolute"), a(k, "type", "search"), a(k, "placeholder", "Search name"), a(M, "class", "blends-actions");
    },
    m(j, $) {
      w(j, e, $), f(e, n), f(n, r), f(e, l), f(l, i), f(l, o), f(e, s), f(s, d), f(s, c), f(e, m), f(m, u), f(e, b), f(b, _), f(b, p), f(e, g), f(g, h), f(g, L), f(e, y), f(y, T), f(y, C), w(j, N, $), w(j, M, $), f(M, k), bt(
        k,
        /*searchValue*/
        t[2]
      ), f(M, I), W && W.m(M, null), f(M, A), le && le.m(M, null), w(j, G, $), B.m(j, $), w(j, ee, $), re || (ce = [
        se(
          k,
          "input",
          /*input_input_handler*/
          t[14]
        ),
        se(
          k,
          "input",
          /*input_handler*/
          t[15]
        )
      ], re = !0);
    },
    p(j, $) {
      $[0] & /*searchValue*/
      4 && k.value !== /*searchValue*/
      j[2] && bt(
        k,
        /*searchValue*/
        j[2]
      ), /*$show_owner_filter*/
      j[6] ? W ? W.p(j, $) : (W = wt(j), W.c(), W.m(M, A)) : W && (W.d(1), W = null), /*$categories*/
      j[7].length ? le ? le.p(j, $) : (le = zt(j), le.c(), le.m(M, null)) : le && (le.d(1), le = null), Q === (Q = ie(j)) && B ? B.p(j, $) : (B.d(1), B = Q(j), B && (B.c(), B.m(ee.parentNode, ee)));
    },
    i: X,
    o: X,
    d(j) {
      j && z(e), j && z(N), j && z(M), W && W.d(), le && le.d(), j && z(G), B.d(j), j && z(ee), re = !1, ve(ce);
    }
  };
}
const at = 1e3;
function or(t, e, n) {
  let r, l, i, o;
  ye(t, be, (B) => n(26, r = B)), ye(t, Oe, (B) => n(6, l = B)), ye(t, Ke, (B) => n(7, i = B)), ye(t, et, (B) => n(8, o = B));
  const s = tt();
  let d, c, m = (/* @__PURE__ */ new Date()).getTime(), u = setTimeout(() => "", 250), b, _ = "", p = "", g, h = 1, L = 0, y = !1;
  const T = async (B, j) => {
    c = await an(`blends-${B.collection}-${o}-${p}-${h}`, () => Dn({
      atomic_url: B.atomic_url,
      collection: B.collection,
      ingredient_match: o,
      ingredient_owner: g,
      page: h,
      category: p
    })), c && (n(2, _ = ""), i.length || Me(Ke, i = c.categories, i), b = Sn({
      items: Object.keys(c.search),
      options: {
        distance: 3,
        results_count: 50,
        results_count_alt: 30
      }
    }), j ? (n(2, _ = j), M(!1)) : n(0, d = vt(Object.values(c.content))), I());
  }, C = be.subscribe(async ({ config: B, blend: j, account: $ }) => {
    var K;
    if (B && !j) {
      if (B.query) {
        const { category: V, page: ne } = B.query;
        V && n(3, p = V), ne && n(4, h = +ne);
      }
      await T(B, (K = B.query) == null ? void 0 : K.search);
    }
    $ ? (g = $.actor, Me(Oe, l = !0, l)) : (g = void 0, Me(Oe, l = !1, l));
  });
  nt(() => {
    const B = setInterval(
      () => {
        n(1, m = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getTime());
      },
      1e3
    );
    return () => {
      clearInterval(B), C();
    };
  });
  const N = (B) => {
    be.update((j) => (j.config.query = {
      search: _,
      page: h.toString(),
      category: p
    }, j)), ge(
      "blend",
      {
        blend_id: B.blend_id,
        contract: B.contract
      },
      s
    );
  }, M = (B = !0) => {
    u && clearTimeout(u), u = setTimeout(
      () => {
        let j = [];
        if (_.length > 0) {
          const $ = b(_);
          if ($) {
            for (let K = 0; K < $.length; K++) {
              const V = c.search[$[K]];
              j.push(c.content[V]);
            }
            n(0, d = void 0);
          }
        } else
          j = vt(Object.values(c.content));
        setTimeout(
          () => {
            n(0, d = j), B && ge(
              "query",
              {
                search: _,
                page: h,
                category: p
              },
              s
            );
          },
          100
        );
      },
      250
    );
  }, k = () => {
    n(0, d = void 0), n(4, h = 1), setTimeout(
      () => {
        ge(
          "query",
          {
            search: _,
            page: h,
            category: p
          },
          s
        ), T(r.config);
      },
      100
    );
  }, I = () => {
    L = (d == null ? void 0 : d.length) || 0, n(5, y = at - L !== at && at - L !== 0);
  }, A = (B) => {
    const j = h ? +h : 1;
    n(4, h = j + B >= 1 ? j + B : 1), n(0, d = void 0), setTimeout(
      () => {
        T(r.config);
      },
      100
    );
  }, G = ({ blend_id: B, contract: j }) => {
    const { config: $ } = r;
    return $ != null && $.blend_link_template ? $.blend_link_template.replace("{contract}", j).replace("{blend_id}", B) : `/blend/${j}/${B}`;
  };
  function ee() {
    _ = this.value, n(2, _);
  }
  const re = () => M();
  function ce() {
    o = pt(this), et.set(o);
  }
  function W() {
    p = pt(this), n(3, p);
  }
  return [
    d,
    m,
    _,
    p,
    h,
    y,
    l,
    i,
    o,
    N,
    M,
    k,
    A,
    G,
    ee,
    re,
    ce,
    W,
    (B) => N(B),
    () => A(-1),
    () => A(1)
  ];
}
class ar extends je {
  constructor(e) {
    super();
    const n = document.createElement("style");
    n.textContent = ':host{--nb-font-family:var(--nefty-font-family, sans-serif);--nb-font-size--small:var(--nefty-font-size--small, 14px);--nb-font-size:var(--nefty-font-size, 16px);--nb-font-size--medium:var(--nefty-font-size, 22px);--nb-font-size--large:var(--nefty-font-size, 26px);--nb-font-size--extra-large:var(--nefty-font-size, 28px);--nb-font-size--title:var(--nefty-font-size, 32px);--nb-card-size-min-m:var(--nefty-card-size-min-mobile, 150px);--nb-card-size-min:var(--nefty-card-size-min, 200px);--nb-card-size-max-m:var(--nefty-card-size-max-mobile, 1fr);--nb-card-size-max:var(--nefty-card-size-max, 1fr);--nb-gap:var(--nefty-gap, 24px);--nb-radius:var(--nefty-radius, 12px);--nb-radius-btn:var(--nefty-radius-btn, 26px);--nb-btn-primary:var(--nefty-btn-primary, #23262f);--nb-btn-primary-hover:var(--nefty-btn-primary-hover, #404555);--nb-btn-secondary:var(--nefty-btn-secondary, #1a1a1a);--nb-btn-secondary-hover:var(--nefty-btn-secondary-hover, #23262f);--nb-border:var(--nefty-border, #353945);--nb-border-card:var(--nefty-border-card, #353945);--nb-border-size:var(--nefty-border-size, 1px);--nb-bg:var(--nefty-bg, #1a1a1a);--nb-bg-card:var(--nefty-bg-card, #23262f);--nb-bg-selected:var(--nefty-bg-selected, #292b31);--nb-bg-footer:var(--nefty-bg-footer, #292c36);--nb-shadow:var(--nefty-shadow, rgba(0, 0, 0, 0.5));--nb-color:var(--nefty-color, #fcfcfd);--nb-color-secondary:var(--nefty-color-secondary, #777e90);--nb-color-highlight:var(--nefty-color-highlight, #00ffff);--nb-button:var(--nefty-button, #21b55a);--nb-secure:var(--nefty-secure, #21abb5);--nb-inactive:var(--nefty-inactive, rgba(182, 44, 44, 0.8));--nb-warning:var(--nefty-warning, rgba(182, 115, 44, 0.8));--nb-highlight:var(--nefty-highlight, #4050b5);--nb-rarity-common:var(--nefty-rarity-common, #353945);--nb-rarity-uncommon:var(--nefty-rarity-uncommon, #4caf50);--nb-rarity-rare:var(--nefty-rarity-rare, #4050b5);--nb-rarity-epic:var(--nefty-rarity-epic, #9c27b0);--nb-rarity-legendary:var(--nefty-rarity-legendary, #ffd500);--nb-markdown-offset:var(--nefty-markdown-offset, 200px);color:var(--nb-color)}:host *{font-family:var(--nb-font-family);font-size:var(--nb-font-size);box-sizing:border-box;margin:0;line-height:1.2}.error,.loading{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:20px;text-align:center;margin-top:30vh}.error svg,.loading svg{color:var(--nb-color-secondary);width:64px;height:64px;animation:shake 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite}.error svg{animation:fallover 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards}@keyframes fallover{0%{transform-origin:50% 0%;transform:rotate(0deg) translate(0, 0)}100%{transform:rotate(90deg) translate(12px, 0)}}@keyframes shake{0%,50%{transform-origin:50% 100%;transform:rotate(3deg)}25%,100%{transform:rotate(-3deg)}}.btn-clear{background:none;border:none;padding:0;cursor:pointer;outline:none}.btn{display:inline-block;padding:8px 16px;border-radius:var(--nb-radius-btn);border:var(--nb-border-size) solid var(--nb-border);background-color:var(--nb-btn-primary);color:var(--nb-color);font-size:var(--nb-font-size--small);font-weight:900;text-decoration:none;text-align:center;cursor:pointer;transition:background-color 0.2s ease-in-out}.btn:hover{background-color:var(--nb-btn-primary-hover)}.btn--primary{font-weight:500;padding:12px 36px}.btn--secondary{font-weight:500;padding:12px 36px;background-color:var(--nb-btn-secondary)}.btn--secondary:hover{background-color:var(--nb-btn-secondary-hover)}.btn--blend{position:relative;overflow:hidden;animation:highlight 3s linear infinite;border:var(--nb-border-size) solid rgba(255, 255, 255, 0.3)}.btn--blend::before{content:"";display:block;position:absolute;height:20px;top:0;left:0;width:100%;transform:skewY(-30deg) translate3d(0, -100px, 0);background-color:rgba(255, 255, 255, 0.3);animation:shine 3s linear infinite}@keyframes highlight{0%,100%{background-color:var(--nb-bg-card)}20%{background-color:var(--nb-highlight)}50%{background-color:var(--nb-bg-card)}}@keyframes shine{0%{transform:skewY(-30deg) translate3d(0, -100%, 0)}20%{transform:skewY(-30deg) translate3d(0, 500%, 0)}100%{transform:skewY(-30deg) translate3d(0, 500%, 0)}}input,select{display:inline-block;padding:8px 16px;border-radius:24px;border:var(--nb-border-size) solid var(--nb-border);background-color:var(--nb-bg);color:var(--nb-color);font-size:var(--nb-font-size--small);outline:none}input::placeholder,select::placeholder{color:var(--nb-color);opacity:0.5}input:active,input:focus,select:active,select:focus{border-color:var(--nb-color-highlight)}select{appearance:none;background-image:linear-gradient(45deg, transparent 50%, var(--nb-border) 50%), linear-gradient(135deg, var(--nb-border) 50%, transparent 50%);background-position:calc(100% - 18px) 16px, calc(100% - 13.1px) 16px;background-size:5px 5px;background-repeat:no-repeat;padding-right:32px;text-transform:capitalize}.blends-actions{display:flex;align-items:center;flex-wrap:wrap;gap:24px;margin-bottom:24px}.blends-group{display:grid;grid-template-columns:repeat(auto-fill, minmax(var(--nb-card-size-min-m), var(--nb-card-size-max-m)));gap:var(--nb-gap)}.blends-item{display:block;position:relative;background-color:var(--nb-bg-card);border-radius:var(--nb-radius);border:var(--nb-border-size) solid var(--nb-border-card);overflow:hidden;padding:12px;transition:transform 0.3s;text-decoration:none}.blends-item .visual{height:auto;max-height:180px;min-height:150px;border-radius:6px;position:relative;z-index:0;overflow:hidden}.blends-item .visual>small{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);color:var(--nb-color)}.blends-item img,.blends-item video{width:100%;height:100%;object-fit:contain}.blends-item img.shadow{position:absolute;top:-10%;left:-10%;width:120%;height:120%;z-index:-1;filter:blur(60px);transform:translate3d(0, 0, 0)}.blends-item .stats{display:flex;align-items:flex-end;justify-content:flex-start;gap:12px;position:absolute;bottom:0;left:0;width:100%;height:100%;padding:12px;background:linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);opacity:0;transition:opacity 0.3s}.blends-item time{display:block;width:fit-content;padding:4px 12px;margin:0 auto;text-transform:uppercase;color:var(--nb-color);transform:translateY(-6px);font-size:var(--nb-font-size--small);background-color:var(--nb-shadow);border-radius:var(--nb-radius)}.blends-item time.ended,.blends-item time.sold-out,.blends-item time.max-reached{background-color:var(--nb-inactive)}.blends-item time svg{display:inline-block;width:13px;height:13px;transform:translate(-4px, 1.5px)}.blends-item .fulfilled{display:inline-block;width:100%;color:var(--nb-color-secondary);text-align:left;font-size:var(--nb-font-size--small)}.blends-item .stat{display:flex;flex-direction:column;text-align:left}.blends-item .stat small{color:var(--nb-color);font-size:var(--nb-font-size--small)}.blends-item .stat span{display:flex;gap:4px;align-items:center;overflow:hidden;text-overflow:ellipsis;color:var(--nb-color-secondary)}.blends-item .stat svg{width:16px;height:16px;color:var(--nb-color-secondary)}.blends-item h3{color:var(--nb-color);height:55px;text-align:left;padding-top:12px}.blends-item h3 svg{margin-right:6px;width:16px;height:16px;color:var(--nb-highlight);transform:translateY(1px)}.blends-item.secure{border-color:var(--nb-highlight)}.blends-item:hover{transform:scale(1.05)}.blends-item:hover .stats{opacity:1}.pagination{display:flex;align-items:center;justify-content:center;gap:var(--nb-gap);padding:12px;margin-top:24px}.pagination button{width:32px;height:32px;color:var(--nb-color);transition:transform 0.15s}.pagination button[disabled]{opacity:0.5;cursor:not-allowed}.pagination button:not([disabled]):hover{transform:scale(1.1)}.pagination svg{width:100%;height:100%}@media all and (min-width: 576px){.blends-group{grid-template-columns:repeat(auto-fill, minmax(var(--nb-card-size-min), var(--nb-card-size-max)))}.blends-item .visual{height:230px;max-height:none}}', this.shadowRoot.appendChild(n), Re(
      this,
      {
        target: this.shadowRoot,
        props: Ge(this.attributes),
        customElement: !0
      },
      or,
      ir,
      xe,
      {},
      null,
      [-1, -1]
    ), e && e.target && w(e.target, this, e.anchor);
  }
}
customElements.define("nefty-blend-group", ar);
function St(t, e, n) {
  const r = t.slice();
  return r[9] = e[n], r[11] = n, r;
}
function Et(t) {
  let e, n, r, l, i, o = (
    /*items*/
    t[0].length > 1 && !/*gridView*/
    t[5] && xt(t)
  );
  function s(b, _) {
    return (
      /*items*/
      b[0].length >= 1 ? cr : sr
    );
  }
  let d = s(t), c = d(t), m = (
    /*items*/
    t[0].length > 1 && !/*gridView*/
    t[5] && qt(t)
  ), u = (
    /*items*/
    t[0].length > 1 && Ht(t)
  );
  return {
    c() {
      e = v("div"), o && o.c(), n = D(), c.c(), r = D(), m && m.c(), l = D(), u && u.c(), a(e, "class", i = "slider " + /*claims*/
      (t[1] ? "claims" : ""));
    },
    m(b, _) {
      w(b, e, _), o && o.m(e, null), f(e, n), c.m(e, null), f(e, r), m && m.m(e, null), f(e, l), u && u.m(e, null);
    },
    p(b, _) {
      /*items*/
      b[0].length > 1 && !/*gridView*/
      b[5] ? o ? o.p(b, _) : (o = xt(b), o.c(), o.m(e, n)) : o && (o.d(1), o = null), d === (d = s(b)) && c ? c.p(b, _) : (c.d(1), c = d(b), c && (c.c(), c.m(e, r))), /*items*/
      b[0].length > 1 && !/*gridView*/
      b[5] ? m ? m.p(b, _) : (m = qt(b), m.c(), m.m(e, l)) : m && (m.d(1), m = null), /*items*/
      b[0].length > 1 ? u ? u.p(b, _) : (u = Ht(b), u.c(), u.m(e, null)) : u && (u.d(1), u = null), _ & /*claims*/
      2 && i !== (i = "slider " + /*claims*/
      (b[1] ? "claims" : "")) && a(e, "class", i);
    },
    d(b) {
      b && z(e), o && o.d(), c.d(), m && m.d(), u && u.d();
    }
  };
}
function xt(t) {
  let e, n, r;
  return {
    c() {
      e = v("button"), e.innerHTML = '<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#arrow_left"></use></svg>', a(e, "class", "btn-clear prev");
    },
    m(l, i) {
      w(l, e, i), n || (r = se(
        e,
        "click",
        /*prev*/
        t[6]
      ), n = !0);
    },
    p: X,
    d(l) {
      l && z(e), n = !1, r();
    }
  };
}
function sr(t) {
  let e;
  return {
    c() {
      e = v("p"), e.textContent = "No result";
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function cr(t) {
  let e, n, r = (
    /*items*/
    t[0]
  ), l = [];
  for (let i = 0; i < r.length; i += 1)
    l[i] = Bt(St(t, r, i));
  return {
    c() {
      e = v("div");
      for (let i = 0; i < l.length; i += 1)
        l[i].c();
      a(e, "class", n = "slider-group " + /*gridView*/
      (t[5] ? "slider-group--grid" : ""));
    },
    m(i, o) {
      w(i, e, o);
      for (let s = 0; s < l.length; s += 1)
        l[s] && l[s].m(e, null);
    },
    p(i, o) {
      if (o & /*items, active, getMarketUrl, platformurl, ended, useTokenDisplay, claims, getDetailUrl*/
      31) {
        r = /*items*/
        i[0];
        let s;
        for (s = 0; s < r.length; s += 1) {
          const d = St(i, r, s);
          l[s] ? l[s].p(d, o) : (l[s] = Bt(d), l[s].c(), l[s].m(e, null));
        }
        for (; s < l.length; s += 1)
          l[s].d(1);
        l.length = r.length;
      }
      o & /*gridView*/
      32 && n !== (n = "slider-group " + /*gridView*/
      (i[5] ? "slider-group--grid" : "")) && a(e, "class", n);
    },
    d(i) {
      i && z(e), He(l, i);
    }
  };
}
function It(t) {
  let e, n, r, l;
  return {
    c() {
      e = v("a"), n = S("svg"), r = S("use"), Ne(r, "xlink:href", "#external"), a(n, "role", "presentation"), a(n, "focusable", "false"), a(n, "aria-hidden", "true"), a(e, "href", l = Qe(
        /*item*/
        t[9].matcher_type,
        /*item*/
        t[9].market_data,
        /*platformurl*/
        t[3]
      )), a(e, "target", "_blank"), a(e, "rel", "noopener");
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(n, r);
    },
    p(i, o) {
      o & /*items, platformurl*/
      9 && l !== (l = Qe(
        /*item*/
        i[9].matcher_type,
        /*item*/
        i[9].market_data,
        /*platformurl*/
        i[3]
      )) && a(e, "href", l);
    },
    d(i) {
      i && z(e);
    }
  };
}
function dr(t) {
  let e;
  return {
    c() {
      e = v("small"), e.textContent = "No result";
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function fr(t) {
  let e, n, r;
  return {
    c() {
      e = v("img"), de(e.src, n = /*item*/
      t[9].image) || a(e, "src", n), a(e, "alt", r = /*item*/
      t[9].name), a(e, "loading", "lazy");
    },
    m(l, i) {
      w(l, e, i);
    },
    p(l, i) {
      i & /*items*/
      1 && !de(e.src, n = /*item*/
      l[9].image) && a(e, "src", n), i & /*items*/
      1 && r !== (r = /*item*/
      l[9].name) && a(e, "alt", r);
    },
    d(l) {
      l && z(e);
    }
  };
}
function ur(t) {
  let e, n;
  return {
    c() {
      e = v("video"), de(e.src, n = /*item*/
      t[9].video) || a(e, "src", n), e.loop = !0, e.autoplay = !0, e.muted = !0, e.playsInline = !0;
    },
    m(r, l) {
      w(r, e, l);
    },
    p(r, l) {
      l & /*items*/
      1 && !de(e.src, n = /*item*/
      r[9].video) && a(e, "src", n);
    },
    d(r) {
      r && z(e);
    }
  };
}
function jt(t) {
  let e, n, r = (
    /*item*/
    t[9].rarity + ""
  ), l;
  return {
    c() {
      e = v("small"), n = O("Rarity: "), l = O(r);
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(e, l);
    },
    p(i, o) {
      o & /*items*/
      1 && r !== (r = /*item*/
      i[9].rarity + "") && P(l, r);
    },
    d(i) {
      i && z(e);
    }
  };
}
function At(t) {
  let e, n = We(
    /*item*/
    t[9].drop_rate,
    2
  ) + "", r, l;
  return {
    c() {
      e = v("small"), r = O(n), l = O(`% Drop
                                    rate`);
    },
    m(i, o) {
      w(i, e, o), f(e, r), f(e, l);
    },
    p(i, o) {
      o & /*items*/
      1 && n !== (n = We(
        /*item*/
        i[9].drop_rate,
        2
      ) + "") && P(r, n);
    },
    d(i) {
      i && z(e);
    }
  };
}
function Ot(t) {
  let e, n, r, l, i = `${/*item*/
  t[9].mint.amount} / ${/*item*/
  t[9].mint.supply}`, o;
  return {
    c() {
      e = v("p"), n = S("svg"), r = S("use"), l = D(), o = O(i), Ne(r, "xlink:href", "#hash"), a(n, "role", "presentation"), a(n, "focusable", "false"), a(n, "aria-hidden", "true");
    },
    m(s, d) {
      w(s, e, d), f(e, n), f(n, r), f(e, l), f(e, o);
    },
    p(s, d) {
      d & /*items*/
      1 && i !== (i = `${/*item*/
      s[9].mint.amount} / ${/*item*/
      s[9].mint.supply}`) && P(o, i);
    },
    d(s) {
      s && z(e);
    }
  };
}
function Dt(t) {
  let e, n, r;
  return {
    c() {
      e = v("a"), n = O("Buy on market"), a(e, "class", "btn"), a(e, "href", r = Xe(
        /*item*/
        t[9].matcher_type,
        /*item*/
        t[9].market_data,
        /*platformurl*/
        t[3]
      )), a(e, "target", "_blank"), a(e, "rel", "noopener");
    },
    m(l, i) {
      w(l, e, i), f(e, n);
    },
    p(l, i) {
      i & /*items, platformurl*/
      9 && r !== (r = Xe(
        /*item*/
        l[9].matcher_type,
        /*item*/
        l[9].market_data,
        /*platformurl*/
        l[3]
      )) && a(e, "href", r);
    },
    d(l) {
      l && z(e);
    }
  };
}
function Bt(t) {
  let e, n, r, l, i, o, s = (
    /*item*/
    t[9].name + ""
  ), d, c, m, u, b, _, p, g = !/*ended*/
  t[2] && /*item*/
  t[9].matcher_type === "template" && It(t);
  function h(k, I) {
    return (
      /*item*/
      k[9].video ? ur : (
        /*item*/
        k[9].image ? fr : dr
      )
    );
  }
  let L = h(t), y = L(t), T = (
    /*claims*/
    t[1] && /*item*/
    t[9].rarity && jt(t)
  ), C = (
    /*item*/
    t[9].drop_rate && !/*claims*/
    t[1] && At(t)
  ), N = (
    /*item*/
    t[9].mint && !/*ended*/
    t[2] && Ot(t)
  ), M = (
    /*ended*/
    t[2] && /*item*/
    t[9].matcher_type === "template" && Dt(t)
  );
  return {
    c() {
      e = v("div"), g && g.c(), n = D(), r = v("figure"), y.c(), l = D(), i = v("article"), o = v("h3"), d = O(s), c = D(), T && T.c(), m = D(), C && C.c(), u = D(), N && N.c(), b = D(), M && M.c(), _ = D(), a(e, "class", p = "slider-item " + /*item*/
      (t[9].rarity || "common") + " " + /*key*/
      (t[11] === /*active*/
      t[4] ? "current" : (
        /*key*/
        t[11] > /*active*/
        t[4] ? "next" : "prev"
      )) + " " + /*key*/
      (t[11] < /*active*/
      t[4] - 1 ? "prev-depth" : "") + " " + /*key*/
      (t[11] > /*active*/
      t[4] + 1 ? "next-depth" : ""));
    },
    m(k, I) {
      w(k, e, I), g && g.m(e, null), f(e, n), f(e, r), y.m(r, null), f(e, l), f(e, i), f(i, o), f(o, d), f(i, c), T && T.m(i, null), f(i, m), C && C.m(i, null), f(i, u), N && N.m(i, null), f(i, b), M && M.m(i, null), f(e, _);
    },
    p(k, I) {
      !/*ended*/
      k[2] && /*item*/
      k[9].matcher_type === "template" ? g ? g.p(k, I) : (g = It(k), g.c(), g.m(e, n)) : g && (g.d(1), g = null), L === (L = h(k)) && y ? y.p(k, I) : (y.d(1), y = L(k), y && (y.c(), y.m(r, null))), I & /*items*/
      1 && s !== (s = /*item*/
      k[9].name + "") && P(d, s), /*claims*/
      k[1] && /*item*/
      k[9].rarity ? T ? T.p(k, I) : (T = jt(k), T.c(), T.m(i, m)) : T && (T.d(1), T = null), /*item*/
      k[9].drop_rate && !/*claims*/
      k[1] ? C ? C.p(k, I) : (C = At(k), C.c(), C.m(i, u)) : C && (C.d(1), C = null), /*item*/
      k[9].mint && !/*ended*/
      k[2] ? N ? N.p(k, I) : (N = Ot(k), N.c(), N.m(i, b)) : N && (N.d(1), N = null), /*ended*/
      k[2] && /*item*/
      k[9].matcher_type === "template" ? M ? M.p(k, I) : (M = Dt(k), M.c(), M.m(i, null)) : M && (M.d(1), M = null), I & /*items, active*/
      17 && p !== (p = "slider-item " + /*item*/
      (k[9].rarity || "common") + " " + /*key*/
      (k[11] === /*active*/
      k[4] ? "current" : (
        /*key*/
        k[11] > /*active*/
        k[4] ? "next" : "prev"
      )) + " " + /*key*/
      (k[11] < /*active*/
      k[4] - 1 ? "prev-depth" : "") + " " + /*key*/
      (k[11] > /*active*/
      k[4] + 1 ? "next-depth" : "")) && a(e, "class", p);
    },
    d(k) {
      k && z(e), g && g.d(), y.d(), T && T.d(), C && C.d(), N && N.d(), M && M.d();
    }
  };
}
function qt(t) {
  let e, n, r;
  return {
    c() {
      e = v("button"), e.innerHTML = '<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#arrow_right"></use></svg>', a(e, "class", "btn-clear next");
    },
    m(l, i) {
      w(l, e, i), n || (r = se(
        e,
        "click",
        /*next*/
        t[7]
      ), n = !0);
    },
    p: X,
    d(l) {
      l && z(e), n = !1, r();
    }
  };
}
function Ht(t) {
  let e, n, r, l, i, o;
  return {
    c() {
      e = v("button"), n = S("svg"), r = S("use"), Ne(r, "xlink:href", l = /*gridView*/
      t[5] ? "#carousel" : "#grid"), a(n, "role", "presentation"), a(n, "focusable", "false"), a(n, "aria-hidden", "true"), a(e, "class", "btn-clear grid");
    },
    m(s, d) {
      w(s, e, d), f(e, n), f(n, r), i || (o = se(
        e,
        "click",
        /*click_handler*/
        t[8]
      ), i = !0);
    },
    p(s, d) {
      d & /*gridView*/
      32 && l !== (l = /*gridView*/
      s[5] ? "#carousel" : "#grid") && Ne(r, "xlink:href", l);
    },
    d(s) {
      s && z(e), i = !1, o();
    }
  };
}
function mr(t) {
  let e, n, r, l, i, o, s, d, c, m, u, b, _, p, g, h, L, y, T, C, N, M, k, I, A, G = (
    /*items*/
    t[0] && Et(t)
  );
  return {
    c() {
      e = S("svg"), n = S("symbol"), r = S("path"), l = S("polyline"), i = S("line"), o = S("symbol"), s = S("line"), d = S("line"), c = S("line"), m = S("line"), u = S("symbol"), b = S("rect"), _ = S("rect"), p = S("rect"), g = S("rect"), h = S("symbol"), L = S("path"), y = S("symbol"), T = S("line"), C = S("polyline"), N = S("symbol"), M = S("line"), k = S("polyline"), I = D(), G && G.c(), A = Ie(), this.c = X, a(r, "d", "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"), a(l, "points", "15 3 21 3 21 9"), a(i, "x1", "10"), a(i, "x2", "21"), a(i, "y1", "14"), a(i, "y2", "3"), a(n, "id", "external"), a(n, "viewBox", "0 0 24 24"), a(n, "fill", "none"), a(n, "stroke", "currentColor"), a(n, "stroke-width", "2"), a(n, "stroke-linecap", "round"), a(n, "stroke-linejoin", "round"), a(s, "x1", "4"), a(s, "y1", "9"), a(s, "x2", "20"), a(s, "y2", "9"), a(d, "x1", "4"), a(d, "y1", "15"), a(d, "x2", "20"), a(d, "y2", "15"), a(c, "x1", "10"), a(c, "y1", "3"), a(c, "x2", "8"), a(c, "y2", "21"), a(m, "x1", "16"), a(m, "y1", "3"), a(m, "x2", "14"), a(m, "y2", "21"), a(o, "id", "hash"), a(o, "viewBox", "0 0 24 24"), a(o, "fill", "none"), a(o, "stroke", "currentColor"), a(o, "stroke-width", "2"), a(o, "stroke-linecap", "round"), a(o, "stroke-linejoin", "round"), a(b, "x", "3"), a(b, "y", "3"), a(b, "width", "7"), a(b, "height", "7"), a(_, "x", "14"), a(_, "y", "3"), a(_, "width", "7"), a(_, "height", "7"), a(p, "x", "14"), a(p, "y", "14"), a(p, "width", "7"), a(p, "height", "7"), a(g, "x", "3"), a(g, "y", "14"), a(g, "width", "7"), a(g, "height", "7"), a(u, "id", "grid"), a(u, "viewBox", "0 0 24 24"), a(u, "fill", "none"), a(u, "stroke", "currentColor"), a(u, "stroke-width", "2"), a(u, "stroke-linecap", "round"), a(u, "stroke-linejoin", "round"), a(L, "d", "M7.556 4h8.888v16H7.556V4zm8.888 1.333H22v13.334h-5.556V5.333zM2 5.333h5.556v13.334H2V5.333z"), a(h, "id", "carousel"), a(h, "viewBox", "0 0 24 24"), a(h, "fill", "none"), a(h, "stroke", "currentColor"), a(h, "stroke-width", "2"), a(h, "stroke-linecap", "round"), a(h, "stroke-linejoin", "round"), a(T, "x1", "5"), a(T, "y1", "12"), a(T, "x2", "19"), a(T, "y2", "12"), a(C, "points", "12 5 19 12 12 19"), a(y, "id", "arrow_right"), a(y, "viewBox", "0 0 24 24"), a(y, "fill", "none"), a(y, "stroke", "currentColor"), a(y, "stroke-width", "2"), a(y, "stroke-linecap", "round"), a(y, "stroke-linejoin", "round"), a(M, "x1", "19"), a(M, "y1", "12"), a(M, "x2", "5"), a(M, "y2", "12"), a(k, "points", "12 19 5 12 12 5"), a(N, "id", "arrow_left"), a(N, "viewBox", "0 0 24 24"), a(N, "fill", "none"), a(N, "stroke", "currentColor"), a(N, "stroke-width", "2"), a(N, "stroke-linecap", "round"), a(N, "stroke-linejoin", "round"), a(e, "aria-hidden", "true"), a(e, "xmlns", "http://www.w3.org/2000/svg"), a(e, "width", "0"), a(e, "height", "0"), $e(e, "position", "absolute");
    },
    m(ee, re) {
      w(ee, e, re), f(e, n), f(n, r), f(n, l), f(n, i), f(e, o), f(o, s), f(o, d), f(o, c), f(o, m), f(e, u), f(u, b), f(u, _), f(u, p), f(u, g), f(e, h), f(h, L), f(e, y), f(y, T), f(y, C), f(e, N), f(N, M), f(N, k), w(ee, I, re), G && G.m(ee, re), w(ee, A, re);
    },
    p(ee, [re]) {
      /*items*/
      ee[0] ? G ? G.p(ee, re) : (G = Et(ee), G.c(), G.m(A.parentNode, A)) : G && (G.d(1), G = null);
    },
    i: X,
    o: X,
    d(ee) {
      ee && z(e), ee && z(I), G && G.d(ee), ee && z(A);
    }
  };
}
function br(t, e, n) {
  let { items: r = void 0 } = e, { claims: l = !1 } = e, { ended: i = !1 } = e, { platformurl: o = null } = e, s = 0, d = !1;
  nt(() => {
    if (r.length) {
      const b = Math.floor(r.length / 2);
      n(4, s = b);
    }
  });
  const c = () => {
    s > 0 ? n(4, s--, s) : n(4, s = r.length - 1);
  }, m = () => {
    s < r.length - 1 ? n(4, s++, s) : n(4, s = 0);
  }, u = () => n(5, d = !d);
  return t.$$set = (b) => {
    "items" in b && n(0, r = b.items), "claims" in b && n(1, l = b.claims), "ended" in b && n(2, i = b.ended), "platformurl" in b && n(3, o = b.platformurl);
  }, [r, l, i, o, s, d, c, m, u];
}
class pr extends je {
  constructor(e) {
    super();
    const n = document.createElement("style");
    n.textContent = ':host{--nb-font-family:var(--nefty-font-family, sans-serif);--nb-font-size--small:var(--nefty-font-size--small, 14px);--nb-font-size:var(--nefty-font-size, 16px);--nb-font-size--medium:var(--nefty-font-size, 22px);--nb-font-size--large:var(--nefty-font-size, 26px);--nb-font-size--extra-large:var(--nefty-font-size, 28px);--nb-font-size--title:var(--nefty-font-size, 32px);--nb-card-size-min-m:var(--nefty-card-size-min-mobile, 150px);--nb-card-size-min:var(--nefty-card-size-min, 200px);--nb-card-size-max-m:var(--nefty-card-size-max-mobile, 1fr);--nb-card-size-max:var(--nefty-card-size-max, 1fr);--nb-gap:var(--nefty-gap, 24px);--nb-radius:var(--nefty-radius, 12px);--nb-radius-btn:var(--nefty-radius-btn, 26px);--nb-btn-primary:var(--nefty-btn-primary, #23262f);--nb-btn-primary-hover:var(--nefty-btn-primary-hover, #404555);--nb-btn-secondary:var(--nefty-btn-secondary, #1a1a1a);--nb-btn-secondary-hover:var(--nefty-btn-secondary-hover, #23262f);--nb-border:var(--nefty-border, #353945);--nb-border-card:var(--nefty-border-card, #353945);--nb-border-size:var(--nefty-border-size, 1px);--nb-bg:var(--nefty-bg, #1a1a1a);--nb-bg-card:var(--nefty-bg-card, #23262f);--nb-bg-selected:var(--nefty-bg-selected, #292b31);--nb-bg-footer:var(--nefty-bg-footer, #292c36);--nb-shadow:var(--nefty-shadow, rgba(0, 0, 0, 0.5));--nb-color:var(--nefty-color, #fcfcfd);--nb-color-secondary:var(--nefty-color-secondary, #777e90);--nb-color-highlight:var(--nefty-color-highlight, #00ffff);--nb-button:var(--nefty-button, #21b55a);--nb-secure:var(--nefty-secure, #21abb5);--nb-inactive:var(--nefty-inactive, rgba(182, 44, 44, 0.8));--nb-warning:var(--nefty-warning, rgba(182, 115, 44, 0.8));--nb-highlight:var(--nefty-highlight, #4050b5);--nb-rarity-common:var(--nefty-rarity-common, #353945);--nb-rarity-uncommon:var(--nefty-rarity-uncommon, #4caf50);--nb-rarity-rare:var(--nefty-rarity-rare, #4050b5);--nb-rarity-epic:var(--nefty-rarity-epic, #9c27b0);--nb-rarity-legendary:var(--nefty-rarity-legendary, #ffd500);--nb-markdown-offset:var(--nefty-markdown-offset, 200px);color:var(--nb-color)}:host *{font-family:var(--nb-font-family);font-size:var(--nb-font-size);box-sizing:border-box;margin:0;line-height:1.2}.btn-clear{background:none;border:none;padding:0;cursor:pointer;outline:none}.btn{display:inline-block;padding:8px 16px;border-radius:var(--nb-radius-btn);border:var(--nb-border-size) solid var(--nb-border);background-color:var(--nb-btn-primary);color:var(--nb-color);font-size:var(--nb-font-size--small);font-weight:900;text-decoration:none;text-align:center;cursor:pointer;transition:background-color 0.2s ease-in-out}.btn:hover{background-color:var(--nb-btn-primary-hover)}.btn--primary{font-weight:500;padding:12px 36px}.btn--secondary{font-weight:500;padding:12px 36px;background-color:var(--nb-btn-secondary)}.btn--secondary:hover{background-color:var(--nb-btn-secondary-hover)}.btn--blend{position:relative;overflow:hidden;animation:highlight 3s linear infinite;border:var(--nb-border-size) solid rgba(255, 255, 255, 0.3)}.btn--blend::before{content:"";display:block;position:absolute;height:20px;top:0;left:0;width:100%;transform:skewY(-30deg) translate3d(0, -100px, 0);background-color:rgba(255, 255, 255, 0.3);animation:shine 3s linear infinite}@keyframes highlight{0%,100%{background-color:var(--nb-bg-card)}20%{background-color:var(--nb-highlight)}50%{background-color:var(--nb-bg-card)}}@keyframes shine{0%{transform:skewY(-30deg) translate3d(0, -100%, 0)}20%{transform:skewY(-30deg) translate3d(0, 500%, 0)}100%{transform:skewY(-30deg) translate3d(0, 500%, 0)}}.slider{display:flex;align-items:center;justify-content:center;width:100%;height:100%;gap:24px;position:relative;overflow:hidden}.slider.claims{opacity:0;animation:show 0.6s 1s ease forwards}@keyframes show{0%{opacity:0}100%{opacity:1}}.btn-clear{width:40px;height:40px;color:var(--nb-color);z-index:4;transition:transform 0.15s ease}.btn-clear:hover{transform:scale(1.1)}.btn-clear:active{transform:scale(0.9)}.btn-clear svg{width:100%;height:100%}.btn-clear.grid{position:absolute;top:12px;right:24px;z-index:1;width:28px;height:28px}.slider-item{position:absolute;height:100%;width:220px;left:0;top:0;background-color:var(--nb-bg-card);border-radius:var(--nb-radius);border:var(--nb-border-size) solid var(--nb-rarity-common);transition:transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1), filter 0.1s linear}.slider-item::before{content:"";position:absolute;top:0;left:0;width:100%;height:100%;border-radius:var(--nb-radius);z-index:-1;opacity:0.1}.slider-item.common{border-color:var(--nb-rarity-common)}.slider-item.common::before{background-color:var(--nb-rarity-common)}.slider-item.common small{color:var(--nb-color-secondary)}.slider-item.uncommon{border-color:var(--nb-rarity-uncommon)}.slider-item.uncommon::before{background-color:var(--nb-rarity-uncommon)}.slider-item.uncommon small{color:var(--nb-rarity-uncommon)}.slider-item.rare{border-color:var(--nb-rarity-rare)}.slider-item.rare::before{background-color:var(--nb-rarity-rare)}.slider-item.rare small{color:var(--nb-rarity-rare)}.slider-item.epic{border-color:var(--nb-rarity-epic)}.slider-item.epic::before{background-color:var(--nb-rarity-epic)}.slider-item.epic small{color:var(--nb-rarity-epic)}.slider-item.legendary{border-color:var(--nb-rarity-legendary)}.slider-item.legendary::before{background-color:var(--nb-rarity-legendary)}.slider-item.legendary small{color:var(--nb-rarity-legendary)}.slider-item figure{display:flex;align-items:center;justify-content:center;width:100%;height:60%;padding:12px;position:relative;overflow:hidden}.slider-item figure small{color:var(--nb-color-secondary);font-size:var(--nb-font-size--small)}.slider-item>a{position:absolute;top:2px;right:3px;transition:transform 0.15s ease;z-index:1}.slider-item>a svg{color:var(--nb-color-secondary);width:18px;height:18px}.slider-item>a:hover{transform:scale(1.1)}.slider-item img,.slider-item video{width:100%;height:100%;object-fit:contain}.slider-item article{text-align:center}.slider-item article h3{margin-bottom:12px;height:21px;padding:0 6px;overflow:hidden}.slider-item article p{display:flex;width:fit-content;gap:8px;margin:12px auto 0;padding:6px 12px 6px 6px;align-items:center;border-radius:18px;background-color:var(--nb-bg)}.slider-item article svg{width:16px;height:16px}.slider-item article .btn{margin-top:12px}.slider-item.current{z-index:3;transform:translate3d(0, 0, 0) rotate(0deg) scale(1)}.slider-item.next{z-index:2;transform:translate3d(30%, 0, 0) rotate(5deg) scale(0.9);filter:brightness(0.8)}.slider-item.next.next-depth{z-index:1;transform:translate3d(55%, 0, 0) rotate(12deg) scale(0.8);filter:brightness(0.5)}.slider-item.next.next-depth+.slider-item.next.next-depth{z-index:0}.slider-item.prev{z-index:2;transform:translate3d(-30%, 0, 0) rotate(-5deg) scale(0.9);filter:brightness(0.8)}.slider-item.prev.prev-depth{z-index:1;transform:translate3d(-55%, 0, 0) rotate(-12deg) scale(0.8);filter:brightness(0.5)}.slider-group{display:block;position:relative;height:276px;width:220px}.slider-group--grid{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;height:100%;width:100%;gap:var(--nb-gap);overflow:hidden auto;padding:var(--nb-gap)}.slider-group--grid .slider-item{position:static;transform:translate3d(0, 0, 0) rotate(0) scale(1);width:clamp(180px, 30vw, 220px);height:276px;z-index:0}.slider-group--grid .slider-item.prev,.slider-group--grid .slider-item.next{z-index:0;filter:brightness(1);transform:translate3d(0, 0, 0) rotate(0) scale(1)}.slider-group--grid .slider-item.prev.prev-depth+.slider-item.prev.prev-depth{filter:brightness(1)}.slider-group--grid .slider-item.next.next-depth+.slider-item.next.next-depth{filter:brightness(1)}.slider-group--grid .slider-item:hover{transform:translate3d(0, 0, 0) rotate(0) scale(1.1)}@media all and (min-width: 768px){.slider{gap:72px}}', this.shadowRoot.appendChild(n), Re(
      this,
      {
        target: this.shadowRoot,
        props: Ge(this.attributes),
        customElement: !0
      },
      br,
      mr,
      xe,
      {
        items: 0,
        claims: 1,
        ended: 2,
        platformurl: 3
      },
      null
    ), e && (e.target && w(e.target, this, e.anchor), e.props && (this.$set(e.props), me()));
  }
  static get observedAttributes() {
    return ["items", "claims", "ended", "platformurl"];
  }
  get items() {
    return this.$$.ctx[0];
  }
  set items(e) {
    this.$$set({ items: e }), me();
  }
  get claims() {
    return this.$$.ctx[1];
  }
  set claims(e) {
    this.$$set({ claims: e }), me();
  }
  get ended() {
    return this.$$.ctx[2];
  }
  set ended(e) {
    this.$$set({ ended: e }), me();
  }
  get platformurl() {
    return this.$$.ctx[3];
  }
  set platformurl(e) {
    this.$$set({ platformurl: e }), me();
  }
}
customElements.define("nefty-blend-slider", pr);
function $t(t, e, n) {
  const r = t.slice();
  return r[11] = e[n], r;
}
function Gt(t) {
  let e, n, r;
  return {
    c() {
      e = v("button"), a(e, "class", "selecter-bg btn-clear");
    },
    m(l, i) {
      w(l, e, i), n || (r = se(
        e,
        "click",
        /*toggleShow*/
        t[5]
      ), n = !0);
    },
    p: X,
    d(l) {
      l && z(e), n = !1, r();
    }
  };
}
function Rt(t) {
  let e, n, r;
  function l(s, d) {
    return (
      /*selected*/
      s[1].length === 1 ? gr : hr
    );
  }
  let i = l(t), o = i(t);
  return {
    c() {
      o.c(), e = D(), n = S("svg"), r = S("use"), a(r, "href", "#chevron_right");
    },
    m(s, d) {
      o.m(s, d), w(s, e, d), w(s, n, d), f(n, r);
    },
    p(s, d) {
      i === (i = l(s)) && o ? o.p(s, d) : (o.d(1), o = i(s), o && (o.c(), o.m(e.parentNode, e)));
    },
    d(s) {
      o.d(s), s && z(e), s && z(n);
    }
  };
}
function hr(t) {
  let e, n = (
    /*selected*/
    t[1].length + ""
  ), r, l;
  return {
    c() {
      e = v("span"), r = O(n), l = O(" items selected");
    },
    m(i, o) {
      w(i, e, o), f(e, r), f(e, l);
    },
    p(i, o) {
      o & /*selected*/
      2 && n !== (n = /*selected*/
      i[1].length + "") && P(r, n);
    },
    d(i) {
      i && z(e);
    }
  };
}
function gr(t) {
  let e, n, r = (
    /*selected*/
    t[1][0].mint + ""
  ), l;
  return {
    c() {
      e = v("span"), n = O("#"), l = O(r);
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(e, l);
    },
    p(i, o) {
      o & /*selected*/
      2 && r !== (r = /*selected*/
      i[1][0].mint + "") && P(l, r);
    },
    d(i) {
      i && z(e);
    }
  };
}
function Ut(t) {
  let e, n, r, l, i, o = (
    /*items*/
    t[0].length + ""
  ), s, d, c, m, u, b, _, p = (
    /*items*/
    t[0]
  ), g = [];
  for (let h = 0; h < p.length; h += 1)
    g[h] = Ft($t(t, p, h));
  return {
    c() {
      e = v("div"), n = v("header"), r = O("Select "), l = O(
        /*amount*/
        t[3]
      ), i = O(" of "), s = O(o), d = D(), c = v("button"), c.innerHTML = '<svg><use href="#undo"></use></svg>', m = D(), u = v("div");
      for (let h = 0; h < g.length; h += 1)
        g[h].c();
      a(c, "class", "btn-clear"), a(c, "title", "Reset selection"), a(e, "class", "selecter-list");
    },
    m(h, L) {
      w(h, e, L), f(e, n), f(n, r), f(n, l), f(n, i), f(n, s), f(n, d), f(n, c), f(e, m), f(e, u);
      for (let y = 0; y < g.length; y += 1)
        g[y] && g[y].m(u, null);
      b || (_ = se(
        c,
        "click",
        /*reset*/
        t[7]
      ), b = !0);
    },
    p(h, L) {
      if (L & /*amount*/
      8 && P(
        l,
        /*amount*/
        h[3]
      ), L & /*items*/
      1 && o !== (o = /*items*/
      h[0].length + "") && P(s, o), L & /*isSelected, items, matchertype, selection*/
      325) {
        p = /*items*/
        h[0];
        let y;
        for (y = 0; y < p.length; y += 1) {
          const T = $t(h, p, y);
          g[y] ? g[y].p(T, L) : (g[y] = Ft(T), g[y].c(), g[y].m(u, null));
        }
        for (; y < g.length; y += 1)
          g[y].d(1);
        g.length = p.length;
      }
    },
    d(h) {
      h && z(e), He(g, h), b = !1, _();
    }
  };
}
function Yt(t) {
  let e;
  function n(i, o) {
    if (
      /*item*/
      i[11].video
    )
      return vr;
    if (
      /*item*/
      i[11].image
    )
      return _r;
  }
  let r = n(t), l = r && r(t);
  return {
    c() {
      l && l.c(), e = Ie();
    },
    m(i, o) {
      l && l.m(i, o), w(i, e, o);
    },
    p(i, o) {
      r === (r = n(i)) && l ? l.p(i, o) : (l && l.d(1), l = r && r(i), l && (l.c(), l.m(e.parentNode, e)));
    },
    d(i) {
      l && l.d(i), i && z(e);
    }
  };
}
function _r(t) {
  let e, n, r;
  return {
    c() {
      e = v("img"), de(e.src, n = /*item*/
      t[11].image) || a(e, "src", n), a(e, "alt", r = /*item*/
      t[11].name), a(e, "loading", "lazy");
    },
    m(l, i) {
      w(l, e, i);
    },
    p(l, i) {
      i & /*items*/
      1 && !de(e.src, n = /*item*/
      l[11].image) && a(e, "src", n), i & /*items*/
      1 && r !== (r = /*item*/
      l[11].name) && a(e, "alt", r);
    },
    d(l) {
      l && z(e);
    }
  };
}
function vr(t) {
  let e, n;
  return {
    c() {
      e = v("video"), de(e.src, n = /*item*/
      t[11].video) || a(e, "src", n), e.loop = !0, e.autoplay = !0, e.muted = !0, e.playsInline = !0;
    },
    m(r, l) {
      w(r, e, l);
    },
    p(r, l) {
      l & /*items*/
      1 && !de(e.src, n = /*item*/
      r[11].video) && a(e, "src", n);
    },
    d(r) {
      r && z(e);
    }
  };
}
function Pt(t) {
  let e, n = (
    /*item*/
    t[11].name + ""
  ), r, l, i = (
    /*item*/
    t[11].value + ""
  ), o;
  return {
    c() {
      e = v("p"), r = O(n), l = O(": "), o = O(i), a(e, "class", "name");
    },
    m(s, d) {
      w(s, e, d), f(e, r), f(e, l), f(e, o);
    },
    p(s, d) {
      d & /*items*/
      1 && n !== (n = /*item*/
      s[11].name + "") && P(r, n), d & /*items*/
      1 && i !== (i = /*item*/
      s[11].value + "") && P(o, i);
    },
    d(s) {
      s && z(e);
    }
  };
}
function Vt(t) {
  let e, n = (
    /*item*/
    t[11].name + ""
  ), r;
  return {
    c() {
      e = v("p"), r = O(n), a(e, "class", "name");
    },
    m(l, i) {
      w(l, e, i), f(e, r);
    },
    p(l, i) {
      i & /*items*/
      1 && n !== (n = /*item*/
      l[11].name + "") && P(r, n);
    },
    d(l) {
      l && z(e);
    }
  };
}
function yr(t) {
  let e;
  return {
    c() {
      e = O("calculating...");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function kr(t) {
  let e, n = (
    /*item*/
    t[11].mint + ""
  ), r;
  return {
    c() {
      e = O("#"), r = O(n);
    },
    m(l, i) {
      w(l, e, i), w(l, r, i);
    },
    p(l, i) {
      i & /*items*/
      1 && n !== (n = /*item*/
      l[11].mint + "") && P(r, n);
    },
    d(l) {
      l && z(e), l && z(r);
    }
  };
}
function Jt(t) {
  let e, n, r = (
    /*item*/
    t[11].rarity + ""
  ), l;
  return {
    c() {
      e = v("p"), n = O("Rarity: "), l = O(r);
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(e, l);
    },
    p(i, o) {
      o & /*items*/
      1 && r !== (r = /*item*/
      i[11].rarity + "") && P(l, r);
    },
    d(i) {
      i && z(e);
    }
  };
}
function Zt(t) {
  let e, n, r = (
    /*item*/
    t[11].backedByTokens + ""
  ), l;
  return {
    c() {
      e = v("p"), n = O("Backed by "), l = O(r), a(e, "class", "badge");
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(e, l);
    },
    p(i, o) {
      o & /*items*/
      1 && r !== (r = /*item*/
      i[11].backedByTokens + "") && P(l, r);
    },
    d(i) {
      i && z(e);
    }
  };
}
function Wt(t) {
  let e, n;
  return {
    c() {
      e = S("svg"), n = S("use"), a(n, "href", "#check");
    },
    m(r, l) {
      w(r, e, l), f(e, n);
    },
    d(r) {
      r && z(e);
    }
  };
}
function Ft(t) {
  let e, n, r, l, i, o, s, d, c, m = (
    /*isSelected*/
    t[6](
      /*item*/
      t[11]
    )
  ), u, b, _, p, g = (
    /*matchertype*/
    (t[2] === "collection" || /*matchertype*/
    t[2] === "attributes" || /*matchertype*/
    t[2] === "schema") && Yt(t)
  ), h = (
    /*matchertype*/
    t[2] === "balance" && Pt(t)
  ), L = (
    /*matchertype*/
    (t[2] === "collection" || /*matchertype*/
    t[2] === "attributes" || /*matchertype*/
    t[2] === "schema") && Vt(t)
  );
  function y(A, G) {
    return (
      /*item*/
      A[11].mint !== 0 ? kr : yr
    );
  }
  let T = y(t), C = T(t), N = (
    /*item*/
    t[11].rarity && Jt(t)
  ), M = (
    /*item*/
    t[11].backedByTokens && Zt(t)
  ), k = m && Wt();
  function I() {
    return (
      /*click_handler*/
      t[9](
        /*item*/
        t[11]
      )
    );
  }
  return {
    c() {
      e = v("button"), g && g.c(), n = D(), r = v("article"), h && h.c(), l = D(), L && L.c(), i = D(), o = v("p"), C.c(), s = D(), N && N.c(), d = D(), M && M.c(), c = D(), k && k.c(), u = D(), a(e, "class", b = "btn-clear " + /*isSelected*/
      (t[6](
        /*item*/
        t[11]
      ) ? "checked" : "") + " " + /*matchertype*/
      t[2]);
    },
    m(A, G) {
      w(A, e, G), g && g.m(e, null), f(e, n), f(e, r), h && h.m(r, null), f(r, l), L && L.m(r, null), f(r, i), f(r, o), C.m(o, null), f(r, s), N && N.m(r, null), f(r, d), M && M.m(r, null), f(e, c), k && k.m(e, null), f(e, u), _ || (p = se(e, "click", I), _ = !0);
    },
    p(A, G) {
      t = A, /*matchertype*/
      t[2] === "collection" || /*matchertype*/
      t[2] === "attributes" || /*matchertype*/
      t[2] === "schema" ? g ? g.p(t, G) : (g = Yt(t), g.c(), g.m(e, n)) : g && (g.d(1), g = null), /*matchertype*/
      t[2] === "balance" ? h ? h.p(t, G) : (h = Pt(t), h.c(), h.m(r, l)) : h && (h.d(1), h = null), /*matchertype*/
      t[2] === "collection" || /*matchertype*/
      t[2] === "attributes" || /*matchertype*/
      t[2] === "schema" ? L ? L.p(t, G) : (L = Vt(t), L.c(), L.m(r, i)) : L && (L.d(1), L = null), T === (T = y(t)) && C ? C.p(t, G) : (C.d(1), C = T(t), C && (C.c(), C.m(o, null))), /*item*/
      t[11].rarity ? N ? N.p(t, G) : (N = Jt(t), N.c(), N.m(r, d)) : N && (N.d(1), N = null), /*item*/
      t[11].backedByTokens ? M ? M.p(t, G) : (M = Zt(t), M.c(), M.m(r, null)) : M && (M.d(1), M = null), G & /*items*/
      1 && (m = /*isSelected*/
      t[6](
        /*item*/
        t[11]
      )), m ? k || (k = Wt(), k.c(), k.m(e, u)) : k && (k.d(1), k = null), G & /*items, matchertype*/
      5 && b !== (b = "btn-clear " + /*isSelected*/
      (t[6](
        /*item*/
        t[11]
      ) ? "checked" : "") + " " + /*matchertype*/
      t[2]) && a(e, "class", b);
    },
    d(A) {
      A && z(e), g && g.d(), h && h.d(), L && L.d(), C.d(), N && N.d(), M && M.d(), k && k.d(), _ = !1, p();
    }
  };
}
function wr(t) {
  let e, n, r, l, i, o, s, d, c, m, u, b, _, p, g, h = (
    /*show*/
    t[4] && Gt(t)
  ), L = (
    /*selected*/
    t[1] && Rt(t)
  ), y = (
    /*show*/
    t[4] && Ut(t)
  );
  return {
    c() {
      e = S("svg"), n = S("symbol"), r = S("polyline"), l = S("symbol"), i = S("path"), o = S("path"), s = S("symbol"), d = S("polyline"), c = D(), h && h.c(), m = D(), u = v("div"), b = v("button"), L && L.c(), _ = D(), y && y.c(), this.c = X, a(r, "points", "20 6 9 17 4 12"), a(n, "id", "check"), a(n, "viewBox", "0 0 24 24"), a(n, "fill", "none"), a(n, "stroke", "currentColor"), a(n, "stroke-width", "2"), a(n, "stroke-linecap", "round"), a(n, "stroke-linejoin", "round"), a(i, "d", "M3 2v6h6"), a(o, "d", "M3 13a9 9 0 1 0 3-7.7L3 8"), a(l, "id", "undo"), a(l, "viewBox", "0 0 24 24"), a(l, "fill", "none"), a(l, "stroke", "currentColor"), a(l, "stroke-width", "2"), a(l, "stroke-linecap", "round"), a(l, "stroke-linejoin", "round"), a(d, "points", "9 18 15 12 9 6"), a(s, "id", "chevron_right"), a(s, "viewBox", "0 0 24 24"), a(s, "fill", "none"), a(s, "stroke", "currentColor"), a(s, "stroke-width", "2"), a(s, "stroke-linecap", "round"), a(s, "stroke-linejoin", "round"), a(e, "aria-hidden", "true"), a(e, "xmlns", "http://www.w3.org/2000/svg"), a(e, "width", "0"), a(e, "height", "0"), $e(e, "position", "absolute"), a(b, "class", "btn-clear selecter-items"), a(u, "class", "selecter");
    },
    m(T, C) {
      w(T, e, C), f(e, n), f(n, r), f(e, l), f(l, i), f(l, o), f(e, s), f(s, d), w(T, c, C), h && h.m(T, C), w(T, m, C), w(T, u, C), f(u, b), L && L.m(b, null), f(u, _), y && y.m(u, null), p || (g = se(
        b,
        "click",
        /*toggleShow*/
        t[5]
      ), p = !0);
    },
    p(T, [C]) {
      /*show*/
      T[4] ? h ? h.p(T, C) : (h = Gt(T), h.c(), h.m(m.parentNode, m)) : h && (h.d(1), h = null), /*selected*/
      T[1] ? L ? L.p(T, C) : (L = Rt(T), L.c(), L.m(b, null)) : L && (L.d(1), L = null), /*show*/
      T[4] ? y ? y.p(T, C) : (y = Ut(T), y.c(), y.m(u, null)) : y && (y.d(1), y = null);
    },
    i: X,
    o: X,
    d(T) {
      T && z(e), T && z(c), h && h.d(T), T && z(m), T && z(u), L && L.d(), y && y.d(), p = !1, g();
    }
  };
}
function zr(t, e, n) {
  const r = tt();
  let { items: l = void 0 } = e, { matchertype: i = void 0 } = e, { selected: o = void 0 } = e, { amount: s = 1 } = e, d = !1;
  const c = () => {
    n(4, d = !d);
  }, m = (p) => o.some((g) => g.asset_id === p.asset_id), u = () => {
    n(1, o = l.slice(0, s)), n(0, l);
  }, b = (p) => {
    m(p) ? n(1, o = o.filter((g) => g.asset_id !== p.asset_id)) : (n(1, o = [...o, p]), o.length > s && n(1, o = o.slice(1))), n(0, l), ge("selected", o, r, !1);
  }, _ = (p) => b(p);
  return t.$$set = (p) => {
    "items" in p && n(0, l = p.items), "matchertype" in p && n(2, i = p.matchertype), "selected" in p && n(1, o = p.selected), "amount" in p && n(3, s = p.amount);
  }, [
    l,
    o,
    i,
    s,
    d,
    c,
    m,
    u,
    b,
    _
  ];
}
class Tr extends je {
  constructor(e) {
    super();
    const n = document.createElement("style");
    n.textContent = ':host{--nb-font-family:var(--nefty-font-family, sans-serif);--nb-font-size--small:var(--nefty-font-size--small, 14px);--nb-font-size:var(--nefty-font-size, 16px);--nb-font-size--medium:var(--nefty-font-size, 22px);--nb-font-size--large:var(--nefty-font-size, 26px);--nb-font-size--extra-large:var(--nefty-font-size, 28px);--nb-font-size--title:var(--nefty-font-size, 32px);--nb-card-size-min-m:var(--nefty-card-size-min-mobile, 150px);--nb-card-size-min:var(--nefty-card-size-min, 200px);--nb-card-size-max-m:var(--nefty-card-size-max-mobile, 1fr);--nb-card-size-max:var(--nefty-card-size-max, 1fr);--nb-gap:var(--nefty-gap, 24px);--nb-radius:var(--nefty-radius, 12px);--nb-radius-btn:var(--nefty-radius-btn, 26px);--nb-btn-primary:var(--nefty-btn-primary, #23262f);--nb-btn-primary-hover:var(--nefty-btn-primary-hover, #404555);--nb-btn-secondary:var(--nefty-btn-secondary, #1a1a1a);--nb-btn-secondary-hover:var(--nefty-btn-secondary-hover, #23262f);--nb-border:var(--nefty-border, #353945);--nb-border-card:var(--nefty-border-card, #353945);--nb-border-size:var(--nefty-border-size, 1px);--nb-bg:var(--nefty-bg, #1a1a1a);--nb-bg-card:var(--nefty-bg-card, #23262f);--nb-bg-selected:var(--nefty-bg-selected, #292b31);--nb-bg-footer:var(--nefty-bg-footer, #292c36);--nb-shadow:var(--nefty-shadow, rgba(0, 0, 0, 0.5));--nb-color:var(--nefty-color, #fcfcfd);--nb-color-secondary:var(--nefty-color-secondary, #777e90);--nb-color-highlight:var(--nefty-color-highlight, #00ffff);--nb-button:var(--nefty-button, #21b55a);--nb-secure:var(--nefty-secure, #21abb5);--nb-inactive:var(--nefty-inactive, rgba(182, 44, 44, 0.8));--nb-warning:var(--nefty-warning, rgba(182, 115, 44, 0.8));--nb-highlight:var(--nefty-highlight, #4050b5);--nb-rarity-common:var(--nefty-rarity-common, #353945);--nb-rarity-uncommon:var(--nefty-rarity-uncommon, #4caf50);--nb-rarity-rare:var(--nefty-rarity-rare, #4050b5);--nb-rarity-epic:var(--nefty-rarity-epic, #9c27b0);--nb-rarity-legendary:var(--nefty-rarity-legendary, #ffd500);--nb-markdown-offset:var(--nefty-markdown-offset, 200px);color:var(--nb-color)}:host *{font-family:var(--nb-font-family);font-size:var(--nb-font-size);box-sizing:border-box;margin:0;line-height:1.2}.btn-clear{background:none;border:none;padding:0;cursor:pointer;outline:none}.btn{display:inline-block;padding:8px 16px;border-radius:var(--nb-radius-btn);border:var(--nb-border-size) solid var(--nb-border);background-color:var(--nb-btn-primary);color:var(--nb-color);font-size:var(--nb-font-size--small);font-weight:900;text-decoration:none;text-align:center;cursor:pointer;transition:background-color 0.2s ease-in-out}.btn:hover{background-color:var(--nb-btn-primary-hover)}.btn--primary{font-weight:500;padding:12px 36px}.btn--secondary{font-weight:500;padding:12px 36px;background-color:var(--nb-btn-secondary)}.btn--secondary:hover{background-color:var(--nb-btn-secondary-hover)}.btn--blend{position:relative;overflow:hidden;animation:highlight 3s linear infinite;border:var(--nb-border-size) solid rgba(255, 255, 255, 0.3)}.btn--blend::before{content:"";display:block;position:absolute;height:20px;top:0;left:0;width:100%;transform:skewY(-30deg) translate3d(0, -100px, 0);background-color:rgba(255, 255, 255, 0.3);animation:shine 3s linear infinite}@keyframes highlight{0%,100%{background-color:var(--nb-bg-card)}20%{background-color:var(--nb-highlight)}50%{background-color:var(--nb-bg-card)}}@keyframes shine{0%{transform:skewY(-30deg) translate3d(0, -100%, 0)}20%{transform:skewY(-30deg) translate3d(0, 500%, 0)}100%{transform:skewY(-30deg) translate3d(0, 500%, 0)}}.selecter-bg{position:fixed;top:0;left:0;z-index:1;width:100%;height:100%;background-color:var(--nb-shadow)}.selecter{width:100%;margin:12px auto 0;padding:0 12px;position:relative}.selecter-items{display:flex;flex-wrap:wrap;gap:8px;width:100%;max-height:48px;overflow:hidden;padding:6px 20px 6px 12px;align-items:center;border-radius:var(--nb-radius);border:var(--nb-border-size) solid var(--nb-border-card);background-color:var(--nb-bg);position:relative;cursor:pointer}.selecter-items span{line-height:1;padding:4px 6px;color:var(--nb-color);font-size:var(--nb-font-size--small);border-radius:var(--nb-radius);background-color:var(--nb-bg-selected);border:var(--nb-border-size) solid var(--nb-border)}.selecter-items svg{position:absolute;top:50%;right:2px;transform:translateY(-50%) rotate(90deg);width:20px;height:20px;color:var(--nb-color-secondary)}.selecter-list{position:absolute;bottom:44px;left:50%;width:360px;max-height:60vh;transform:translateX(-50%);border-radius:var(--nb-radius);background-color:var(--nb-bg-card);border:var(--nb-border-size) solid var(--nb-border-card);box-shadow:0 0 26px 0 var(--nb-shadow);overflow:hidden auto;z-index:1}.selecter-list header{display:flex;justify-content:center;align-items:center;position:relative;padding:6px;height:44px;color:var(--nb-color-secondary);font-size:var(--nb-font-size--small);border-bottom:var(--nb-border-size) solid var(--nb-border-card)}.selecter-list header button{display:flex;align-items:center;position:absolute;top:9px;left:6px;padding:5px;color:var(--nb-color);font-size:var(--nb-font-size--small);border-radius:14px;background-color:var(--nb-bg);border:var(--nb-border-size) solid var(--nb-border)}.selecter-list header button svg{width:14px;height:14px}.selecter-list>div{display:flex;flex-direction:column;height:100%;width:100%}.selecter-list>div button{display:flex;align-items:center;color:var(--nb-color-secondary);text-align:left;padding:12px 6px;border-bottom:var(--nb-border-size) solid var(--nb-border-card)}.selecter-list>div button img,.selecter-list>div button video{object-fit:contain;width:75px;height:75px;margin-right:6px}.selecter-list>div button svg{width:18px;height:18px;margin-left:auto;color:var(--nb-color)}.selecter-list>div button.checked{color:var(--nb-color)}.selecter-list>div button.collection .name,.selecter-list>div button.attributes .name,.selecter-list>div button.schema .name,.selecter-list>div button.balance .name{color:var(--nb-color-secondary);font-size:var(--nb-font-size--small);margin-bottom:6px}.selecter-list>div button:hover{background-color:rgba(255, 255, 255, 0.1)}.selecter-list>div button:last-child{border-bottom:none}.badge{padding:3px 6px;margin-top:6px;border-radius:6px;font-size:var(--nb-font-size--small);color:var(--nb-color);background-color:var(--nb-inactive)}', this.shadowRoot.appendChild(n), Re(
      this,
      {
        target: this.shadowRoot,
        props: Ge(this.attributes),
        customElement: !0
      },
      zr,
      wr,
      xe,
      {
        items: 0,
        matchertype: 2,
        selected: 1,
        amount: 3
      },
      null
    ), e && (e.target && w(e.target, this, e.anchor), e.props && (this.$set(e.props), me()));
  }
  static get observedAttributes() {
    return ["items", "matchertype", "selected", "amount"];
  }
  get items() {
    return this.$$.ctx[0];
  }
  set items(e) {
    this.$$set({ items: e }), me();
  }
  get matchertype() {
    return this.$$.ctx[2];
  }
  set matchertype(e) {
    this.$$set({ matchertype: e }), me();
  }
  get selected() {
    return this.$$.ctx[1];
  }
  set selected(e) {
    this.$$set({ selected: e }), me();
  }
  get amount() {
    return this.$$.ctx[3];
  }
  set amount(e) {
    this.$$set({ amount: e }), me();
  }
}
customElements.define("nefty-blend-selecter", Tr);
function Xt(t, e, n) {
  const r = t.slice();
  return r[39] = e[n], r[41] = n, r;
}
function Mr(t) {
  let e;
  return {
    c() {
      e = v("p"), e.innerHTML = `<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#blender"></use></svg>
        loading blend...`, a(e, "class", "loading");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function Nr(t) {
  let e;
  return {
    c() {
      e = v("p"), e.innerHTML = `<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#blender"></use></svg>
        Whoops someone spilled the juice!`, a(e, "class", "error");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function Lr(t) {
  let e, n, r, l, i, o, s, d = (
    /*data*/
    t[2].name + ""
  ), c, m, u, b, _ = (["active", "ended"].includes(
    /*data*/
    t[2].status
  ) ? _e(
    /*data*/
    t[2].start_time,
    /*data*/
    t[2].end_time,
    /*now*/
    t[11]
  ) : ke(
    /*data*/
    t[2].status
  )) + "", p, g, h, L, y, T, C, N, M, k, I, A, G, ee, re, ce, W, le, ie, Q, B, j = (
    /*data*/
    t[2].count.current !== /*data*/
    (t[2].count.max || "∞") && Qt(t)
  ), $ = (
    /*warnJobs*/
    t[7] >= 50 && Kt(t)
  );
  function K(x, Z) {
    return (
      /*showClaims*/
      x[13] ? Sr : Cr
    );
  }
  let V = K(t), ne = V(t), F = (
    /*data*/
    t[2].account_limit !== 0 && en(t)
  ), te = (
    /*secureClaimError*/
    t[8] && tn(t)
  );
  function E(x, Z) {
    return (
      /*showClaims*/
      x[13] ? Or : Ar
    );
  }
  let H = E(t), J = H(t), Y = (
    /*data*/
    t[2].items
  ), q = [];
  for (let x = 0; x < Y.length; x += 1)
    q[x] = ln(Xt(t, Y, x));
  let R = (
    /*data*/
    t[2].description && !/*showClaims*/
    t[13] && on(t)
  );
  return {
    c() {
      e = v("button"), e.innerHTML = `<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#arrow_left"></use></svg>
        Blends`, n = D(), r = v("div"), l = v("main"), i = v("article"), o = v("div"), s = v("h1"), c = O(d), m = D(), u = v("span"), b = v("time"), p = O(_), g = D(), j && j.c(), h = D(), $ && $.c(), L = D(), y = v("section"), ne.c(), T = D(), C = v("section"), F && F.c(), N = D(), te && te.c(), M = D(), k = v("section"), J.c(), I = D(), A = v("section"), G = v("h2"), G.textContent = "Ingredients", ee = D(), re = v("small"), re.textContent = "Ingredients will be consumed", ce = D(), W = v("div");
      for (let x = 0; x < q.length; x += 1)
        q[x].c();
      le = D(), R && R.c(), a(e, "class", "btn-clear back"), a(i, "class", "blend-content"), a(y, "class", "blend-results"), a(C, "class", "blend-info"), a(k, "class", "blend-actions"), a(W, "class", "selection-group"), a(A, "class", "blend-selection"), a(r, "class", ie = "blend " + /*data*/
      (t[2].description ? "" : "no-text") + " " + /*showClaims*/
      (t[13] ? "claims" : ""));
    },
    m(x, Z) {
      w(x, e, Z), w(x, n, Z), w(x, r, Z), f(r, l), f(l, i), f(i, o), f(o, s), f(s, c), f(o, m), f(o, u), f(u, b), f(b, p), f(u, g), j && j.m(u, null), f(i, h), $ && $.m(i, null), f(l, L), f(l, y), ne.m(y, null), f(l, T), f(l, C), F && F.m(C, null), f(C, N), te && te.m(C, null), f(l, M), f(l, k), J.m(k, null), f(l, I), f(l, A), f(A, G), f(A, ee), f(A, re), f(A, ce), f(A, W);
      for (let U = 0; U < q.length; U += 1)
        q[U] && q[U].m(W, null);
      t[25](W), f(r, le), R && R.m(r, null), Q || (B = se(
        e,
        "click",
        /*close*/
        t[19]
      ), Q = !0);
    },
    p(x, Z) {
      if (Z[0] & /*data*/
      4 && d !== (d = /*data*/
      x[2].name + "") && P(c, d), Z[0] & /*data, now*/
      2052 && _ !== (_ = (["active", "ended"].includes(
        /*data*/
        x[2].status
      ) ? _e(
        /*data*/
        x[2].start_time,
        /*data*/
        x[2].end_time,
        /*now*/
        x[11]
      ) : ke(
        /*data*/
        x[2].status
      )) + "") && P(p, _), /*data*/
      x[2].count.current !== /*data*/
      (x[2].count.max || "∞") ? j ? j.p(x, Z) : (j = Qt(x), j.c(), j.m(u, null)) : j && (j.d(1), j = null), /*warnJobs*/
      x[7] >= 50 ? $ ? $.p(x, Z) : ($ = Kt(x), $.c(), $.m(i, null)) : $ && ($.d(1), $ = null), V === (V = K(x)) && ne ? ne.p(x, Z) : (ne.d(1), ne = V(x), ne && (ne.c(), ne.m(y, null))), /*data*/
      x[2].account_limit !== 0 ? F ? F.p(x, Z) : (F = en(x), F.c(), F.m(C, N)) : F && (F.d(1), F = null), /*secureClaimError*/
      x[8] ? te ? te.p(x, Z) : (te = tn(x), te.c(), te.m(C, null)) : te && (te.d(1), te = null), H === (H = E(x)) && J ? J.p(x, Z) : (J.d(1), J = H(x), J && (J.c(), J.m(k, null))), Z[0] & /*user, selection, data, selected, updateSelection, localConfig, hasVisual*/
      294959) {
        Y = /*data*/
        x[2].items;
        let U;
        for (U = 0; U < Y.length; U += 1) {
          const oe = Xt(x, Y, U);
          q[U] ? q[U].p(oe, Z) : (q[U] = ln(oe), q[U].c(), q[U].m(W, null));
        }
        for (; U < q.length; U += 1)
          q[U].d(1);
        q.length = Y.length;
      }
      /*data*/
      x[2].description && !/*showClaims*/
      x[13] ? R ? R.p(x, Z) : (R = on(x), R.c(), R.m(r, null)) : R && (R.d(1), R = null), Z[0] & /*data, showClaims*/
      8196 && ie !== (ie = "blend " + /*data*/
      (x[2].description ? "" : "no-text") + " " + /*showClaims*/
      (x[13] ? "claims" : "")) && a(r, "class", ie);
    },
    d(x) {
      x && z(e), x && z(n), x && z(r), j && j.d(), $ && $.d(), ne.d(), F && F.d(), te && te.d(), J.d(), He(q, x), t[25](null), R && R.d(), Q = !1, B();
    }
  };
}
function Qt(t) {
  let e, n, r = (
    /*data*/
    t[2].count.current + ""
  ), l, i, o = (
    /*data*/
    (t[2].count.max || "∞") + ""
  ), s, d;
  return {
    c() {
      e = v("small"), e.textContent = "-", n = D(), l = O(r), i = O(" / "), s = O(o), d = O(` blends
                            left`);
    },
    m(c, m) {
      w(c, e, m), w(c, n, m), w(c, l, m), w(c, i, m), w(c, s, m), w(c, d, m);
    },
    p(c, m) {
      m[0] & /*data*/
      4 && r !== (r = /*data*/
      c[2].count.current + "") && P(l, r), m[0] & /*data*/
      4 && o !== (o = /*data*/
      (c[2].count.max || "∞") + "") && P(s, o);
    },
    d(c) {
      c && z(e), c && z(n), c && z(l), c && z(i), c && z(s), c && z(d);
    }
  };
}
function Kt(t) {
  let e, n, r, l, i;
  return {
    c() {
      e = v("div"), n = v("p"), r = O("There are "), l = O(
        /*warnJobs*/
        t[7]
      ), i = O(` pending jobs, the blend results
                            may be delayed.`), a(e, "class", "banner");
    },
    m(o, s) {
      w(o, e, s), f(e, n), f(n, r), f(n, l), f(n, i);
    },
    p(o, s) {
      s[0] & /*warnJobs*/
      128 && P(
        l,
        /*warnJobs*/
        o[7]
      );
    },
    d(o) {
      o && z(e);
    }
  };
}
function Cr(t) {
  let e, n, r, l, i, o, s;
  return {
    c() {
      e = v("nefty-blend-slider"), i = D(), o = v("img"), fe(e, "items", n = /*data*/
      t[2].results), fe(e, "claims", !1), fe(e, "ended", r = /*data*/
      t[2].status !== "active"), fe(e, "platformurl", l = /*localConfig*/
      t[1].platform_url), a(o, "class", "result-bg"), de(o.src, s = /*data*/
      t[2].backgroundImg || "") || a(o, "src", s), a(o, "alt", ""), a(o, "loading", "lazy");
    },
    m(d, c) {
      w(d, e, c), w(d, i, c), w(d, o, c);
    },
    p(d, c) {
      c[0] & /*data*/
      4 && n !== (n = /*data*/
      d[2].results) && fe(e, "items", n), c[0] & /*data*/
      4 && r !== (r = /*data*/
      d[2].status !== "active") && fe(e, "ended", r), c[0] & /*localConfig*/
      2 && l !== (l = /*localConfig*/
      d[1].platform_url) && fe(e, "platformurl", l), c[0] & /*data*/
      4 && !de(o.src, s = /*data*/
      d[2].backgroundImg || "") && a(o, "src", s);
    },
    d(d) {
      d && z(e), d && z(i), d && z(o);
    }
  };
}
function Sr(t) {
  let e, n, r;
  return {
    c() {
      e = v("nefty-blend-slider"), n = D(), r = v("div"), fe(
        e,
        "items",
        /*claims*/
        t[6]
      ), fe(e, "claims", !0), a(r, "class", "result-bg"), $e(r, "background-image", "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIiIGZpbGw9IiNmZmYiIGNsaXAtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xNSA0NGMtLjggMC0xLjUtLjMtMi4xLS45LS42LS42LS45LTEuMy0uOS0yLjF2LTJhOC44IDguOCAwIDAgMSA0LjQtNy42bC0yLTEwSDljLS44IDAtMS41LS4zLTIuMS0xLS42LS41LS45LTEuMi0uOS0yVjkuNWMwLS44LjMtMS41LjktMi4xLjYtLjYgMS4zLS45IDIuMS0uOWgyN2wtNC40IDI0LjljMS40IDEgMi41IDIgMy4zIDMuNEE3LjQgNy40IDAgMCAxIDM2IDM5djJjMCAuOC0uMyAxLjUtLjkgMi4xLS42LjYtMS4zLjktMi4xLjlIMTVabS0xLjItMjUuNkwxMiA5LjVIOXY4LjhsNC44LjFabTUuMyAxMS4xaDkuOGwzLjUtMjBIMTUuMWw0IDIwWk0xNSA0MWgxOHYtMmMwLTEuOC0uNy0zLjMtMi00LjZhNyA3IDAgMCAwLTUtMS45aC00Yy0yIDAtMy43LjctNSAyYTYuMiA2LjIgMCAwIDAtMiA0LjV2MloiLz48L3N2Zz4=')");
    },
    m(l, i) {
      w(l, e, i), w(l, n, i), w(l, r, i);
    },
    p(l, i) {
      i[0] & /*claims*/
      64 && fe(
        e,
        "items",
        /*claims*/
        l[6]
      );
    },
    d(l) {
      l && z(e), l && z(n), l && z(r);
    }
  };
}
function en(t) {
  let e, n, r;
  function l(s, d) {
    return (
      /*limits*/
      s[4] ? xr : Er
    );
  }
  let i = l(t), o = i(t);
  return {
    c() {
      e = v("p"), n = v("span"), n.textContent = "Account limit:", r = D(), o.c(), a(e, "class", "account-limit");
    },
    m(s, d) {
      w(s, e, d), f(e, n), f(e, r), o.m(e, null);
    },
    p(s, d) {
      i === (i = l(s)) && o ? o.p(s, d) : (o.d(1), o = i(s), o && (o.c(), o.m(e, null)));
    },
    d(s) {
      s && z(e), o.d();
    }
  };
}
function Er(t) {
  let e;
  return {
    c() {
      e = O("loading...");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function xr(t) {
  let e;
  function n(i, o) {
    return (
      /*limits*/
      i[4].allowed ? jr : Ir
    );
  }
  let r = n(t), l = r(t);
  return {
    c() {
      l.c(), e = Ie();
    },
    m(i, o) {
      l.m(i, o), w(i, e, o);
    },
    p(i, o) {
      r === (r = n(i)) && l ? l.p(i, o) : (l.d(1), l = r(i), l && (l.c(), l.m(e.parentNode, e)));
    },
    d(i) {
      l.d(i), i && z(e);
    }
  };
}
function Ir(t) {
  let e = (
    /*limits*/
    t[4].reason + ""
  ), n, r, l = (
    /*countdown*/
    t[16](
      /*now*/
      t[11]
    ) + ""
  ), i;
  return {
    c() {
      n = O(e), r = D(), i = O(l);
    },
    m(o, s) {
      w(o, n, s), w(o, r, s), w(o, i, s);
    },
    p(o, s) {
      s[0] & /*limits*/
      16 && e !== (e = /*limits*/
      o[4].reason + "") && P(n, e), s[0] & /*now*/
      2048 && l !== (l = /*countdown*/
      o[16](
        /*now*/
        o[11]
      ) + "") && P(i, l);
    },
    d(o) {
      o && z(n), o && z(r), o && z(i);
    }
  };
}
function jr(t) {
  let e = (
    /*limits*/
    t[4].left + ""
  ), n, r, l = (
    /*countdown*/
    t[16](
      /*now*/
      t[11]
    ) + ""
  ), i;
  return {
    c() {
      n = O(e), r = D(), i = O(l);
    },
    m(o, s) {
      w(o, n, s), w(o, r, s), w(o, i, s);
    },
    p(o, s) {
      s[0] & /*limits*/
      16 && e !== (e = /*limits*/
      o[4].left + "") && P(n, e), s[0] & /*now*/
      2048 && l !== (l = /*countdown*/
      o[16](
        /*now*/
        o[11]
      ) + "") && P(i, l);
    },
    d(o) {
      o && z(n), o && z(r), o && z(i);
    }
  };
}
function tn(t) {
  let e, n, r, l;
  return {
    c() {
      e = v("div"), n = v("p"), r = O("Secure blend: "), l = O(
        /*secureClaimError*/
        t[8]
      ), a(e, "class", "banner banner--warn");
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(n, r), f(n, l);
    },
    p(i, o) {
      o[0] & /*secureClaimError*/
      256 && P(
        l,
        /*secureClaimError*/
        i[8]
      );
    },
    d(i) {
      i && z(e);
    }
  };
}
function Ar(t) {
  let e, n, r = (
    /*loading*/
    (t[12] ? "Loading" : (
      /*user*/
      t[0] ? (
        /*data*/
        t[2].status !== "active" ? ke(
          /*data*/
          t[2].status
        ) : Te(
          /*data*/
          t[2].start_time,
          /*data*/
          t[2].end_time,
          /*now*/
          t[11]
        ) ? (
          /*data*/
          t[2].secure ? "Secure blend" : "Blend"
        ) : _e(
          /*data*/
          t[2].start_time,
          /*data*/
          t[2].end_time,
          /*now*/
          t[11]
        )
      ) : "Not logged in"
    )) + ""
  ), l, i, o, s, d, c, m;
  return {
    c() {
      e = v("div"), n = v("button"), l = O(r), s = D(), d = v("button"), d.innerHTML = '<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#refresh"></use></svg>', n.disabled = i = !/*allowBlend*/
      t[14] || /*loading*/
      t[12] || !/*user*/
      t[0] || /*data*/
      t[2].status !== "active" || !Te(
        /*data*/
        t[2].start_time,
        /*data*/
        t[2].end_time,
        /*now*/
        t[11]
      ), a(n, "class", o = "btn btn--primary " + (!/*loading*/
      t[12] && /*isMeetingRequirements*/
      t[9] && Te(
        /*data*/
        t[2].start_time,
        /*data*/
        t[2].end_time,
        /*now*/
        t[11]
      ) ? "btn--blend" : "")), a(d, "class", "btn btn--secondary btn-refresh"), a(e, "class", "btn-group");
    },
    m(u, b) {
      w(u, e, b), f(e, n), f(n, l), f(e, s), f(e, d), c || (m = [
        se(
          n,
          "click",
          /*click_handler*/
          t[22]
        ),
        se(
          d,
          "click",
          /*click_handler_1*/
          t[23]
        )
      ], c = !0);
    },
    p(u, b) {
      b[0] & /*loading, user, data, now*/
      6149 && r !== (r = /*loading*/
      (u[12] ? "Loading" : (
        /*user*/
        u[0] ? (
          /*data*/
          u[2].status !== "active" ? ke(
            /*data*/
            u[2].status
          ) : Te(
            /*data*/
            u[2].start_time,
            /*data*/
            u[2].end_time,
            /*now*/
            u[11]
          ) ? (
            /*data*/
            u[2].secure ? "Secure blend" : "Blend"
          ) : _e(
            /*data*/
            u[2].start_time,
            /*data*/
            u[2].end_time,
            /*now*/
            u[11]
          )
        ) : "Not logged in"
      )) + "") && P(l, r), b[0] & /*allowBlend, loading, user, data, now*/
      22533 && i !== (i = !/*allowBlend*/
      u[14] || /*loading*/
      u[12] || !/*user*/
      u[0] || /*data*/
      u[2].status !== "active" || !Te(
        /*data*/
        u[2].start_time,
        /*data*/
        u[2].end_time,
        /*now*/
        u[11]
      )) && (n.disabled = i), b[0] & /*loading, isMeetingRequirements, data, now*/
      6660 && o !== (o = "btn btn--primary " + (!/*loading*/
      u[12] && /*isMeetingRequirements*/
      u[9] && Te(
        /*data*/
        u[2].start_time,
        /*data*/
        u[2].end_time,
        /*now*/
        u[11]
      ) ? "btn--blend" : "")) && a(n, "class", o);
    },
    d(u) {
      u && z(e), c = !1, ve(m);
    }
  };
}
function Or(t) {
  let e, n, r = (
    /*loading*/
    t[12] ? "Loading" : "Blend again"
  ), l, i, o, s, d, c, m;
  return {
    c() {
      e = v("div"), n = v("button"), l = O(r), i = D(), o = v("a"), s = O("See my profile"), n.disabled = /*loading*/
      t[12], a(n, "class", "btn btn--primary btn--blend"), a(o, "href", d = /*localConfig*/
      t[1].platform_url + "/profile/" + /*user*/
      t[0].actor + "?collection_name=" + /*localConfig*/
      t[1].collection), a(o, "target", "_blank"), a(o, "rel", "noopener noreferrer"), a(o, "class", "btn btn--primary btn--primary"), a(e, "class", "btn-group");
    },
    m(u, b) {
      w(u, e, b), f(e, n), f(n, l), f(e, i), f(e, o), f(o, s), c || (m = se(
        n,
        "click",
        /*reset*/
        t[21]
      ), c = !0);
    },
    p(u, b) {
      b[0] & /*loading*/
      4096 && r !== (r = /*loading*/
      u[12] ? "Loading" : "Blend again") && P(l, r), b[0] & /*loading*/
      4096 && (n.disabled = /*loading*/
      u[12]), b[0] & /*localConfig, user*/
      3 && d !== (d = /*localConfig*/
      u[1].platform_url + "/profile/" + /*user*/
      u[0].actor + "?collection_name=" + /*localConfig*/
      u[1].collection) && a(o, "href", d);
    },
    d(u) {
      u && z(e), c = !1, m();
    }
  };
}
function Dr(t) {
  let e;
  return {
    c() {
      e = v("span"), a(e, "class", "loading-state");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function Br(t) {
  let e, n, r = (
    /*item*/
    t[39].matcher_type + ""
  ), l, i, o, s, d, c, m, u = (
    /*item*/
    t[39].name + ""
  ), b, _, p, g, h = (
    /*item*/
    t[39].matcher_type !== "token" && nn(t)
  );
  function L(I, A) {
    return A[0] & /*data*/
    4 && (s = null), s == null && (s = !!/*hasVisual*/
    I[15].includes(
      /*item*/
      I[39].matcher_type
    )), s ? $r : Hr;
  }
  let y = L(t, [-1, -1]), T = y(t), C = (
    /*item*/
    t[39].value && rn(t)
  );
  function N(I, A) {
    return A[0] & /*selection, data*/
    12 && (p = null), /*item*/
    I[39].matcher_type !== "token" ? Pr : (p == null && (p = !!dn(
      /*selection*/
      I[3][
        /*item*/
        I[39].matcher
      ],
      /*data*/
      I[2].requirements[
        /*item*/
        I[39].matcher
      ]
    )), p ? Yr : Ur);
  }
  let M = N(t, [-1, -1]), k = M(t);
  return {
    c() {
      e = v("div"), n = v("small"), l = O(r), i = D(), h && h.c(), o = D(), T.c(), d = D(), c = v("h3"), C && C.c(), m = D(), b = O(u), _ = D(), k.c(), a(n, "class", "type"), a(e, "class", g = Fe(
        /*selection*/
        t[3][
          /*item*/
          t[39].matcher
        ],
        /*data*/
        t[2].requirements[
          /*item*/
          t[39].matcher
        ],
        !0
      ) ? "owned" : "needed");
    },
    m(I, A) {
      w(I, e, A), f(e, n), f(n, l), f(n, i), h && h.m(n, null), f(e, o), T.m(e, null), f(e, d), f(e, c), C && C.m(c, null), f(c, m), f(c, b), f(e, _), k.m(e, null);
    },
    p(I, A) {
      A[0] & /*data*/
      4 && r !== (r = /*item*/
      I[39].matcher_type + "") && P(l, r), /*item*/
      I[39].matcher_type !== "token" ? h ? h.p(I, A) : (h = nn(I), h.c(), h.m(n, null)) : h && (h.d(1), h = null), y === (y = L(I, A)) && T ? T.p(I, A) : (T.d(1), T = y(I), T && (T.c(), T.m(e, d))), /*item*/
      I[39].value ? C ? C.p(I, A) : (C = rn(I), C.c(), C.m(c, m)) : C && (C.d(1), C = null), A[0] & /*data*/
      4 && u !== (u = /*item*/
      I[39].name + "") && P(b, u), M === (M = N(I, A)) && k ? k.p(I, A) : (k.d(1), k = M(I), k && (k.c(), k.m(e, null))), A[0] & /*selection, data*/
      12 && g !== (g = Fe(
        /*selection*/
        I[3][
          /*item*/
          I[39].matcher
        ],
        /*data*/
        I[2].requirements[
          /*item*/
          I[39].matcher
        ],
        !0
      ) ? "owned" : "needed") && a(e, "class", g);
    },
    d(I) {
      I && z(e), h && h.d(), T.d(), C && C.d(), k.d();
    }
  };
}
function qr(t) {
  let e;
  return {
    c() {
      e = v("span"), e.innerHTML = `<svg role="presentation" focusable="false" aria-hidden="true"><use xlink:href="#ghost"></use></svg> 
                                    <small>Our friendly ghost is here to remind you
                                        to log in first</small>`, a(e, "class", "no-user");
    },
    m(n, r) {
      w(n, e, r);
    },
    p: X,
    d(n) {
      n && z(e);
    }
  };
}
function nn(t) {
  let e, n, r, l;
  return {
    c() {
      e = v("a"), n = S("svg"), r = S("use"), Ne(r, "xlink:href", "#external"), a(n, "role", "presentation"), a(n, "focusable", "false"), a(n, "aria-hidden", "true"), a(e, "href", l = Qe(
        /*item*/
        t[39].matcher_type,
        /*item*/
        t[39].market_data,
        /*localConfig*/
        t[1].platform_url
      )), a(e, "target", "_blank"), a(e, "rel", "noopener");
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(n, r);
    },
    p(i, o) {
      o[0] & /*data, localConfig*/
      6 && l !== (l = Qe(
        /*item*/
        i[39].matcher_type,
        /*item*/
        i[39].market_data,
        /*localConfig*/
        i[1].platform_url
      )) && a(e, "href", l);
    },
    d(i) {
      i && z(e);
    }
  };
}
function Hr(t) {
  let e, n = (
    /*item*/
    (t[39].description ? (
      /*item*/
      t[39].description
    ) : " ") + ""
  ), r;
  return {
    c() {
      e = v("span"), r = O(n), a(e, "class", "visual visual--small");
    },
    m(l, i) {
      w(l, e, i), f(e, r);
    },
    p(l, i) {
      i[0] & /*data*/
      4 && n !== (n = /*item*/
      (l[39].description ? (
        /*item*/
        l[39].description
      ) : " ") + "") && P(r, n);
    },
    d(l) {
      l && z(e);
    }
  };
}
function $r(t) {
  let e, n;
  function r(o, s) {
    if (
      /*item*/
      o[39].video
    )
      return Rr;
    if (
      /*item*/
      o[39].image
    )
      return Gr;
  }
  let l = r(t), i = l && l(t);
  return {
    c() {
      e = v("figure"), i && i.c(), a(e, "class", n = "visual " + /*item*/
      t[39].matcher_type);
    },
    m(o, s) {
      w(o, e, s), i && i.m(e, null);
    },
    p(o, s) {
      l === (l = r(o)) && i ? i.p(o, s) : (i && i.d(1), i = l && l(o), i && (i.c(), i.m(e, null))), s[0] & /*data*/
      4 && n !== (n = "visual " + /*item*/
      o[39].matcher_type) && a(e, "class", n);
    },
    d(o) {
      o && z(e), i && i.d();
    }
  };
}
function Gr(t) {
  let e, n, r;
  return {
    c() {
      e = v("img"), de(e.src, n = /*item*/
      t[39].image) || a(e, "src", n), a(e, "alt", r = /*item*/
      t[39].name), a(e, "loading", "lazy");
    },
    m(l, i) {
      w(l, e, i);
    },
    p(l, i) {
      i[0] & /*data*/
      4 && !de(e.src, n = /*item*/
      l[39].image) && a(e, "src", n), i[0] & /*data*/
      4 && r !== (r = /*item*/
      l[39].name) && a(e, "alt", r);
    },
    d(l) {
      l && z(e);
    }
  };
}
function Rr(t) {
  let e, n;
  return {
    c() {
      e = v("video"), de(e.src, n = /*item*/
      t[39].video) || a(e, "src", n), e.loop = !0, e.autoplay = !0, e.muted = !0, e.playsInline = !0;
    },
    m(r, l) {
      w(r, e, l);
    },
    p(r, l) {
      l[0] & /*data*/
      4 && !de(e.src, n = /*item*/
      r[39].video) && a(e, "src", n);
    },
    d(r) {
      r && z(e);
    }
  };
}
function rn(t) {
  let e = (
    /*item*/
    t[39].value + ""
  ), n;
  return {
    c() {
      n = O(e);
    },
    m(r, l) {
      w(r, n, l);
    },
    p(r, l) {
      l[0] & /*data*/
      4 && e !== (e = /*item*/
      r[39].value + "") && P(n, e);
    },
    d(r) {
      r && z(n);
    }
  };
}
function Ur(t) {
  let e, n, r = (
    /*item*/
    t[39].token.token_symbol + ""
  ), l;
  return {
    c() {
      e = v("a"), n = O("Get more "), l = O(r), a(e, "class", "btn"), a(e, "href", "#"), a(e, "target", "_blank"), a(e, "rel", "noopener");
    },
    m(i, o) {
      w(i, e, o), f(e, n), f(e, l);
    },
    p(i, o) {
      o[0] & /*data*/
      4 && r !== (r = /*item*/
      i[39].token.token_symbol + "") && P(l, r);
    },
    d(i) {
      i && z(e);
    }
  };
}
function Yr(t) {
  let e, n, r, l = gt(
    /*selection*/
    t[3][
      /*item*/
      t[39].matcher
    ],
    2
  ) + "", i, o, s, d = (
    /*item*/
    t[39].token.token_symbol + ""
  ), c;
  return {
    c() {
      e = v("p"), n = v("small"), n.textContent = "current balance", r = D(), i = O(l), o = D(), s = v("span"), c = O(d), a(e, "class", "balance");
    },
    m(m, u) {
      w(m, e, u), f(e, n), f(e, r), f(e, i), f(e, o), f(e, s), f(s, c);
    },
    p(m, u) {
      u[0] & /*selection, data*/
      12 && l !== (l = gt(
        /*selection*/
        m[3][
          /*item*/
          m[39].matcher
        ],
        2
      ) + "") && P(i, l), u[0] & /*data*/
      4 && d !== (d = /*item*/
      m[39].token.token_symbol + "") && P(c, d);
    },
    d(m) {
      m && z(e);
    }
  };
}
function Pr(t) {
  let e, n;
  function r(o, s) {
    return s[0] & /*selection, data*/
    12 && (e = null), e == null && (e = !!Fe(
      /*selection*/
      o[3][
        /*item*/
        o[39].matcher
      ],
      /*data*/
      o[2].requirements[
        /*item*/
        o[39].matcher
      ],
      !0
    )), e ? Jr : Vr;
  }
  let l = r(t, [-1, -1]), i = l(t);
  return {
    c() {
      i.c(), n = Ie();
    },
    m(o, s) {
      i.m(o, s), w(o, n, s);
    },
    p(o, s) {
      l === (l = r(o, s)) && i ? i.p(o, s) : (i.d(1), i = l(o), i && (i.c(), i.m(n.parentNode, n)));
    },
    d(o) {
      i.d(o), o && z(n);
    }
  };
}
function Vr(t) {
  var y, T, C;
  let e, n, r = (
    /*data*/
    t[2].requirements[
      /*item*/
      t[39].matcher
    ].amount - /*selected*/
    (((y = t[5][
      /*item*/
      t[39].matcher
    ]) == null ? void 0 : y.length) || 0) + ""
  ), l, i, o = (
    /*data*/
    t[2].requirements[
      /*item*/
      t[39].matcher
    ].amount - /*selected*/
    (((T = t[5][
      /*item*/
      t[39].matcher
    ]) == null ? void 0 : T.length) || 0) === 1 ? "" : "s"
  ), s, d, c, m, u = (
    /*selected*/
    (((C = t[5][
      /*item*/
      t[39].matcher
    ]) == null ? void 0 : C.length) || 0) + ""
  ), b, _, p = (
    /*data*/
    t[2].requirements[
      /*item*/
      t[39].matcher
    ].amount + ""
  ), g, h, L;
  return {
    c() {
      e = v("a"), n = O("Get "), l = O(r), i = O(" asset"), s = O(o), d = D(), c = v("small"), m = O("("), b = O(u), _ = O("/"), g = O(p), h = O(")"), a(e, "class", "btn"), a(e, "href", L = Xe(
        /*item*/
        t[39].matcher_type,
        /*item*/
        t[39].market_data,
        /*localConfig*/
        t[1].platform_url
      )), a(e, "target", "_blank"), a(e, "rel", "noopener");
    },
    m(N, M) {
      w(N, e, M), f(e, n), f(e, l), f(e, i), f(e, s), f(e, d), f(e, c), f(c, m), f(c, b), f(c, _), f(c, g), f(c, h);
    },
    p(N, M) {
      var k, I, A;
      M[0] & /*data, selected*/
      36 && r !== (r = /*data*/
      N[2].requirements[
        /*item*/
        N[39].matcher
      ].amount - /*selected*/
      (((k = N[5][
        /*item*/
        N[39].matcher
      ]) == null ? void 0 : k.length) || 0) + "") && P(l, r), M[0] & /*data, selected*/
      36 && o !== (o = /*data*/
      N[2].requirements[
        /*item*/
        N[39].matcher
      ].amount - /*selected*/
      (((I = N[5][
        /*item*/
        N[39].matcher
      ]) == null ? void 0 : I.length) || 0) === 1 ? "" : "s") && P(s, o), M[0] & /*selected, data*/
      36 && u !== (u = /*selected*/
      (((A = N[5][
        /*item*/
        N[39].matcher
      ]) == null ? void 0 : A.length) || 0) + "") && P(b, u), M[0] & /*data*/
      4 && p !== (p = /*data*/
      N[2].requirements[
        /*item*/
        N[39].matcher
      ].amount + "") && P(g, p), M[0] & /*data, localConfig*/
      6 && L !== (L = Xe(
        /*item*/
        N[39].matcher_type,
        /*item*/
        N[39].market_data,
        /*localConfig*/
        N[1].platform_url
      )) && a(e, "href", L);
    },
    d(N) {
      N && z(e);
    }
  };
}
function Jr(t) {
  let e, n, r, l, i, o, s;
  function d(...c) {
    return (
      /*selected_handler*/
      t[24](
        /*item*/
        t[39],
        ...c
      )
    );
  }
  return {
    c() {
      e = v("nefty-blend-selecter"), fe(e, "items", n = /*selection*/
      t[3][
        /*item*/
        t[39].matcher
      ]), fe(e, "matchertype", r = /*item*/
      t[39].matcher_type), fe(e, "amount", l = /*data*/
      t[2].requirements[
        /*item*/
        t[39].matcher
      ].amount), fe(e, "selected", i = /*selected*/
      t[5][
        /*item*/
        t[39].matcher
      ]);
    },
    m(c, m) {
      w(c, e, m), o || (s = se(e, "selected", d), o = !0);
    },
    p(c, m) {
      t = c, m[0] & /*selection, data*/
      12 && n !== (n = /*selection*/
      t[3][
        /*item*/
        t[39].matcher
      ]) && fe(e, "items", n), m[0] & /*data*/
      4 && r !== (r = /*item*/
      t[39].matcher_type) && fe(e, "matchertype", r), m[0] & /*data*/
      4 && l !== (l = /*data*/
      t[2].requirements[
        /*item*/
        t[39].matcher
      ].amount) && fe(e, "amount", l), m[0] & /*selected, data*/
      36 && i !== (i = /*selected*/
      t[5][
        /*item*/
        t[39].matcher
      ]) && fe(e, "selected", i);
    },
    d(c) {
      c && z(e), o = !1, s();
    }
  };
}
function ln(t) {
  let e, n;
  function r(o, s) {
    return (
      /*user*/
      o[0] ? (
        /*selection*/
        o[3] ? Br : Dr
      ) : qr
    );
  }
  let l = r(t), i = l(t);
  return {
    c() {
      e = v("div"), i.c(), n = D(), a(e, "class", "selection-item");
    },
    m(o, s) {
      w(o, e, s), i.m(e, null), f(e, n);
    },
    p(o, s) {
      l === (l = r(o)) && i ? i.p(o, s) : (i.d(1), i = l(o), i && (i.c(), i.m(e, n)));
    },
    d(o) {
      o && z(e), i.d();
    }
  };
}
function on(t) {
  let e, n, r, l = (
    /*data*/
    t[2].description + ""
  ), i, o;
  return {
    c() {
      e = v("aside"), n = v("article"), r = new gn(!1), i = D(), o = v("template"), o.innerHTML = `<h1>0</h1> 
                        <h2>0</h2> 
                        <h3>0</h3> 
                        <h4>0</h4> 
                        <h5>0</h5> 
                        <strong></strong> 
                        <p></p> 
                        <ul></ul> 
                        <li></li> 
                        <a href="#0">0</a> 
                        <img alt=""/> 
                        <table><th></th> 
                            <td></td></table>`, r.a = i, a(n, "class", "markdown"), a(e, "class", "blend-text");
    },
    m(s, d) {
      w(s, e, d), f(e, n), r.m(l, n), f(n, i), f(n, o);
    },
    p(s, d) {
      d[0] & /*data*/
      4 && l !== (l = /*data*/
      s[2].description + "") && r.p(l);
    },
    d(s) {
      s && z(e);
    }
  };
}
function Zr(t) {
  let e, n, r, l, i, o, s, d, c, m, u, b, _, p, g, h, L, y, T, C, N;
  function M(A, G) {
    return (
      /*data*/
      A[2] ? Lr : (
        /*data*/
        A[2] === null ? Nr : Mr
      )
    );
  }
  let k = M(t), I = k(t);
  return {
    c() {
      e = S("svg"), n = S("symbol"), r = S("path"), l = S("polyline"), i = S("line"), o = S("symbol"), s = S("path"), d = S("path"), c = S("path"), m = S("path"), u = S("symbol"), b = S("line"), _ = S("polyline"), p = S("symbol"), g = S("path"), h = S("path"), L = S("path"), y = S("symbol"), T = S("path"), C = D(), I.c(), N = Ie(), this.c = X, a(r, "d", "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"), a(l, "points", "15 3 21 3 21 9"), a(i, "x1", "10"), a(i, "x2", "21"), a(i, "y1", "14"), a(i, "y2", "3"), a(n, "id", "external"), a(n, "viewBox", "0 0 24 24"), a(n, "fill", "none"), a(n, "stroke", "currentColor"), a(n, "stroke-width", "2"), a(n, "stroke-linecap", "round"), a(n, "stroke-linejoin", "round"), a(s, "d", "M21 2v6h-6"), a(d, "d", "M3 12a9 9 0 0 1 15-6.7L21 8"), a(c, "d", "M3 22v-6h6"), a(m, "d", "M21 12a9 9 0 0 1-15 6.7L3 16"), a(o, "id", "refresh"), a(o, "viewBox", "0 0 24 24"), a(o, "fill", "none"), a(o, "stroke", "currentColor"), a(o, "stroke-width", "2"), a(o, "stroke-linecap", "round"), a(o, "stroke-linejoin", "round"), a(b, "x1", "19"), a(b, "y1", "12"), a(b, "x2", "5"), a(b, "y2", "12"), a(_, "points", "12 19 5 12 12 5"), a(u, "id", "arrow_left"), a(u, "viewBox", "0 0 24 24"), a(u, "fill", "none"), a(u, "stroke", "currentColor"), a(u, "stroke-width", "2"), a(u, "stroke-linecap", "round"), a(u, "stroke-linejoin", "round"), a(g, "d", "M9 10h.01"), a(h, "d", "M15 10h.01"), a(L, "d", "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z"), a(p, "id", "ghost"), a(p, "viewBox", "0 0 24 24"), a(p, "fill", "none"), a(p, "stroke", "currentColor"), a(p, "stroke-width", "2"), a(p, "stroke-linecap", "round"), a(p, "stroke-linejoin", "round"), a(T, "fill-rule", "nonzero"), a(T, "d", "M15 44c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1v-2a8.8 8.8 0 0 1 4.4-7.6l-2-10H9c-.8 0-1.5-.3-2.1-1-.6-.5-.9-1.2-.9-2V9.5c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h27l-4.4 24.9c1.4 1 2.5 2 3.3 3.4A7.4 7.4 0 0 1 36 39v2c0 .8-.3 1.5-.9 2.1-.6.6-1.3.9-2.1.9H15Zm-1.2-25.6L12 9.5H9v8.8l4.8.1Zm5.3 11.1h9.8l3.5-20H15.1l4 20ZM15 41h18v-2c0-1.8-.7-3.3-2-4.6a7 7 0 0 0-5-1.9h-4c-2 0-3.7.7-5 2a6.2 6.2 0 0 0-2 4.5v2Z"), a(y, "id", "blender"), a(y, "xml:space", "preserve"), a(y, "fill-rule", "evenodd"), a(y, "fill", "currentColor"), a(y, "stroke-linejoin", "round"), a(y, "stroke-miterlimit", "2"), a(y, "clip-rule", "evenodd"), a(y, "viewBox", "0 0 48 48"), a(e, "aria-hidden", "true"), a(e, "xmlns", "http://www.w3.org/2000/svg"), a(e, "width", "0"), a(e, "height", "0"), $e(e, "position", "absolute");
    },
    m(A, G) {
      w(A, e, G), f(e, n), f(n, r), f(n, l), f(n, i), f(e, o), f(o, s), f(o, d), f(o, c), f(o, m), f(e, u), f(u, b), f(u, _), f(e, p), f(p, g), f(p, h), f(p, L), f(e, y), f(y, T), w(A, C, G), I.m(A, G), w(A, N, G);
    },
    p(A, G) {
      k === (k = M(A)) && I ? I.p(A, G) : (I.d(1), I = k(A), I && (I.c(), I.m(N.parentNode, N)));
    },
    i: X,
    o: X,
    d(A) {
      A && z(e), A && z(C), I.d(A), A && z(N);
    }
  };
}
function Wr(t, e, n) {
  const r = tt();
  let l, i, o, s, d, c = {}, m = null, u = 0, b = null, _ = !1, p, g = (/* @__PURE__ */ new Date()).getTime(), h = !0, L = !1, y = !0, T = [], C = [], N = [], M = null;
  const k = ["collection", "template", "token", "balance"], I = async (E, H, J) => {
    const Y = await an(
      `blend-${E.blend_id}`,
      () => On({
        atomic_url: H.atomic_url,
        blend_id: E.blend_id,
        contract: E.contract,
        chain: H.chain
      }),
      6e5,
      J
    );
    Y.collection_name === H.collection ? (n(2, o = Y), o.odds && n(7, u = await Pn({ chain_url: H.chain_url }))) : o !== null && (ge(
      "error",
      {
        type: "invalid",
        message: "Blend is not from this collection"
      },
      r
    ), n(2, o = null));
  }, A = be.subscribe(async ({ config: E, blend: H, account: J, transactionId: Y }) => {
    if (n(0, l = J), E && H && !Y && (n(1, i = E), await I(H, E, !1)), J && H && !Y) {
      if (o != null && o.requirements ? await W() : n(3, s = void 0), o != null && o.secure) {
        n(14, y = !1);
        const { allowed: q, result: R, reason: x } = await Vn({
          atomic_url: E.atomic_url,
          chain_url: E.chain_url,
          security_id: o.security_id,
          actor: l.actor,
          collection: E.collection
        });
        q ? (n(14, y = !0), M = R, n(8, b = null)) : n(8, b = x);
      }
      o.account_limit !== 0 && await ee();
    }
    if (Y)
      if (n(12, h = !0), Y !== "unset") {
        const q = H.contract;
        q === "blend.nefty" ? n(6, m = await Yn({
          atomic_url: E.atomic_url,
          blend_id: H.blend_id,
          contract: q,
          tx_id: Y
        })) : q === "blenderizerx" ? n(6, m = o.results) : n(6, m = []), n(13, L = !0), setTimeout(
          () => {
            be.update((R) => (R.transactionId = null, R)), E && H && G(E, H);
          },
          1e3
        );
      } else
        be.update((q) => (q.transactionId = null, q)), E && H && G(E, H);
    n(12, h = !1);
  });
  nt(() => {
    const E = setInterval(
      () => {
        n(11, g = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getTime());
      },
      1e3
    );
    return () => {
      clearInterval(E), A();
    };
  });
  const G = async (E, H) => {
    await I(H, E, !0);
  }, ee = async () => {
    n(4, d = await Jn({
      chain_url: i.chain_url,
      blend_id: o.blend_id,
      actor: l.actor,
      account_limit: o.account_limit,
      account_limit_cooldown: o.account_limit_cooldown
    })), n(14, y = d.allowed), d.wait > 0 && setTimeout(
      async () => {
        await ee();
      },
      d.wait * 1e3 + 1e3
    );
  };
  let re = 0;
  const ce = (E) => {
    if (d.wait > 0) {
      re || (re = E + d.wait * 1e3);
      const H = qe(re, E);
      return H === "0" && (re = 0), `refresh in ${H}`;
    } else
      return o.account_limit_cooldown !== 0 ? `every ${xn(o.account_limit_cooldown)}` : "";
  }, W = async () => {
    n(3, s = void 0), n(5, c = {}), T = [], C = [], N = [], n(3, s = await Un({
      requirements: o.requirements,
      atomic_url: i.atomic_url,
      chain_url: i.chain_url,
      actor: l.actor
    })), ie(o.requirements), n(9, _ = Q(o.requirements, !0, !1));
  }, le = ({ detail: E }, H) => {
    n(5, c[H] = E, c);
  }, ie = (E) => {
    const H = _t(E), J = [];
    for (let Y = 0; Y < H.length; Y++) {
      const { matcher: q, matcher_type: R, amount: x, value: Z } = H[Y];
      if (R === "token") {
        const [U] = s[q].split(" ");
        +U >= Z && n(5, c[q] = s[q], c);
      } else if (s[q] && s[q].length) {
        const U = [...s[q]];
        for (let oe = 0; oe < U.length; oe++) {
          const he = U[oe];
          J.includes(he.asset_id) && (U.splice(oe, 1), oe--);
        }
        n(5, c[q] = U.slice(0, x), c);
        for (let oe = 0; oe < c[q].length; oe++) {
          const he = c[q][oe];
          J.push(he.asset_id);
        }
      }
    }
  }, Q = (E, H = !1, J = !1) => {
    const Y = _t(E);
    T = [], C = [], N = [];
    let q = !0;
    for (let R = 0; R < Y.length; R++) {
      const { matcher: x, matcher_type: Z, token: U } = Y[R];
      if (Z === "token")
        if (dn(c[x], Y[R]))
          C.push(U);
        else {
          J && ge(
            "error",
            {
              type: "requirements",
              message: "missing token"
            },
            r
          ), q = !1;
          break;
        }
      else if (Fe(c[x], Y[R], H))
        for (let oe = 0; oe < c[x].length; oe++) {
          const { asset_id: he } = c[x][oe];
          if (!T.includes(he) && !N.includes(he))
            Z === "balance" ? N.push(he) : T.push(he);
          else {
            J && ge(
              "error",
              {
                type: "requirements",
                message: "duplicate asset"
              },
              r
            ), q = !1;
            break;
          }
        }
      else {
        J && ge(
          "error",
          {
            type: "requirements",
            message: "missing asset"
          },
          r
        ), q = !1;
        break;
      }
    }
    return q;
  }, B = () => {
    ge("blend", null, r);
  }, j = (E) => {
    if (Q(E, !0, !0)) {
      const J = En({
        account: l,
        blend_id: o.blend_id,
        contract: o.contract,
        asset_ids: T,
        balance_asset_ids: N,
        tokens: C,
        security_check: M
      });
      K(), n(12, h = !0), ge("sign", J, r);
    }
  }, $ = async () => {
    n(12, h = !0), await W(), n(13, L = !1), n(6, m = null), n(12, h = !1);
  }, K = () => {
    const E = p.querySelectorAll(".selection-item > div"), H = p.getBoundingClientRect().left + p.getBoundingClientRect().width / 2;
    E.forEach((J, Y) => {
      const q = J.getBoundingClientRect().left + 100, R = H - q;
      J.animate(
        [
          { transform: "translate3d(0, 0, 0)" },
          {
            transform: `translate3d(${R}px, -200%, 0)`,
            opacity: 1
          },
          {
            transform: `translate3d(${R}px, -200%, 0)`,
            opacity: 0
          }
        ],
        {
          duration: 1e3,
          delay: 50 * Y,
          easing: "cubic-bezier(0.7, 0.06, 0.42, 0.99)",
          fill: "forwards"
        }
      );
    });
  }, V = () => {
    y && Te(o.start_time, o.end_time, g) && j(o.requirements);
  }, ne = () => W(), F = (E, H) => le(H, E.matcher);
  function te(E) {
    ct[E ? "unshift" : "push"](() => {
      p = E, n(10, p);
    });
  }
  return [
    l,
    i,
    o,
    s,
    d,
    c,
    m,
    u,
    b,
    _,
    p,
    g,
    h,
    L,
    y,
    k,
    ce,
    W,
    le,
    B,
    j,
    $,
    V,
    ne,
    F,
    te
  ];
}
class Fr extends je {
  constructor(e) {
    super();
    const n = document.createElement("style");
    n.textContent = ':host{--nb-font-family:var(--nefty-font-family, sans-serif);--nb-font-size--small:var(--nefty-font-size--small, 14px);--nb-font-size:var(--nefty-font-size, 16px);--nb-font-size--medium:var(--nefty-font-size, 22px);--nb-font-size--large:var(--nefty-font-size, 26px);--nb-font-size--extra-large:var(--nefty-font-size, 28px);--nb-font-size--title:var(--nefty-font-size, 32px);--nb-card-size-min-m:var(--nefty-card-size-min-mobile, 150px);--nb-card-size-min:var(--nefty-card-size-min, 200px);--nb-card-size-max-m:var(--nefty-card-size-max-mobile, 1fr);--nb-card-size-max:var(--nefty-card-size-max, 1fr);--nb-gap:var(--nefty-gap, 24px);--nb-radius:var(--nefty-radius, 12px);--nb-radius-btn:var(--nefty-radius-btn, 26px);--nb-btn-primary:var(--nefty-btn-primary, #23262f);--nb-btn-primary-hover:var(--nefty-btn-primary-hover, #404555);--nb-btn-secondary:var(--nefty-btn-secondary, #1a1a1a);--nb-btn-secondary-hover:var(--nefty-btn-secondary-hover, #23262f);--nb-border:var(--nefty-border, #353945);--nb-border-card:var(--nefty-border-card, #353945);--nb-border-size:var(--nefty-border-size, 1px);--nb-bg:var(--nefty-bg, #1a1a1a);--nb-bg-card:var(--nefty-bg-card, #23262f);--nb-bg-selected:var(--nefty-bg-selected, #292b31);--nb-bg-footer:var(--nefty-bg-footer, #292c36);--nb-shadow:var(--nefty-shadow, rgba(0, 0, 0, 0.5));--nb-color:var(--nefty-color, #fcfcfd);--nb-color-secondary:var(--nefty-color-secondary, #777e90);--nb-color-highlight:var(--nefty-color-highlight, #00ffff);--nb-button:var(--nefty-button, #21b55a);--nb-secure:var(--nefty-secure, #21abb5);--nb-inactive:var(--nefty-inactive, rgba(182, 44, 44, 0.8));--nb-warning:var(--nefty-warning, rgba(182, 115, 44, 0.8));--nb-highlight:var(--nefty-highlight, #4050b5);--nb-rarity-common:var(--nefty-rarity-common, #353945);--nb-rarity-uncommon:var(--nefty-rarity-uncommon, #4caf50);--nb-rarity-rare:var(--nefty-rarity-rare, #4050b5);--nb-rarity-epic:var(--nefty-rarity-epic, #9c27b0);--nb-rarity-legendary:var(--nefty-rarity-legendary, #ffd500);--nb-markdown-offset:var(--nefty-markdown-offset, 200px);color:var(--nb-color)}:host *{font-family:var(--nb-font-family);font-size:var(--nb-font-size);box-sizing:border-box;margin:0;line-height:1.2}.error,.loading{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:20px;text-align:center;margin-top:30vh}.error svg,.loading svg{color:var(--nb-color-secondary);width:64px;height:64px;animation:shake 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite}.error svg{animation:fallover 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards}@keyframes fallover{0%{transform-origin:50% 0%;transform:rotate(0deg) translate(0, 0)}100%{transform:rotate(90deg) translate(12px, 0)}}@keyframes shake{0%,50%{transform-origin:50% 100%;transform:rotate(3deg)}25%,100%{transform:rotate(-3deg)}}.markdown p{margin-bottom:12px;line-height:1.2;color:var(--nb-color);word-break:break-word}.markdown ul{margin-bottom:12px}.markdown li{line-height:1.2;color:var(--nb-color)}.markdown img{display:block;width:100%;max-width:800px;margin:0 auto 12px}.markdown h1,.markdown h2,.markdown h3,.markdown h4,.markdown h5{margin-bottom:12px}.markdown h1{font-size:var(--nb-font-size--title)}.markdown h2{font-size:var(--nb-font-size--extra-large)}.markdown h3{font-size:var(--nb-font-size--large)}.markdown h4{font-size:var(--nb-font-size--medium)}.markdown h5{font-size:var(--nb-font-size)}.markdown h1,.markdown h2,.markdown h3,.markdown h4,.markdown h5,.markdown strong{color:var(--nb-color);font-weight:900}.markdown a{color:var(--nb-color-highlight);text-decoration:underline}.markdown a:hover{text-decoration:underline}.markdown table{width:fit-content;margin-bottom:12px;border-collapse:collapse;border-spacing:0;border:var(--nb-border-size) solid var(--nb-border);font-size:var(--nb-font-size);line-height:1.2}.markdown table th{padding:6px;border:var(--nb-border-size) solid var(--nb-border);text-align:left;background-color:var(--nb-bg-card)}.markdown table th:empty{display:none}.markdown table td{padding:6px;border:var(--nb-border-size) solid var(--nb-border)}.btn-clear{background:none;border:none;padding:0;cursor:pointer;outline:none}.btn{display:inline-block;padding:8px 16px;border-radius:var(--nb-radius-btn);border:var(--nb-border-size) solid var(--nb-border);background-color:var(--nb-btn-primary);color:var(--nb-color);font-size:var(--nb-font-size--small);font-weight:900;text-decoration:none;text-align:center;cursor:pointer;transition:background-color 0.2s ease-in-out}.btn:hover{background-color:var(--nb-btn-primary-hover)}.btn[disabled]{opacity:0.5;cursor:not-allowed}.btn--primary{font-weight:500;padding:12px 36px}.btn--secondary{font-weight:500;padding:12px 36px;background-color:var(--nb-btn-secondary)}.btn--secondary:hover{background-color:var(--nb-btn-secondary-hover)}.btn--blend{position:relative;overflow:hidden;animation:highlight 3s linear infinite;border:var(--nb-border-size) solid rgba(255, 255, 255, 0.3)}.btn--blend::before{content:"";display:block;position:absolute;height:20px;top:0;left:0;width:100%;transform:skewY(-30deg) translate3d(0, -100px, 0);background-color:rgba(255, 255, 255, 0.3);animation:shine 3s linear infinite}.btn--blend[disabled]{animation:none}.btn--blend[disabled]::before{animation:none}@keyframes highlight{0%,100%{background-color:var(--nb-bg-card)}20%{background-color:var(--nb-highlight)}50%{background-color:var(--nb-bg-card)}}@keyframes shine{0%{transform:skewY(-30deg) translate3d(0, -100%, 0)}20%{transform:skewY(-30deg) translate3d(0, 500%, 0)}100%{transform:skewY(-30deg) translate3d(0, 500%, 0)}}.blend{display:grid;grid-template-columns:1fr;gap:48px 0}.blend.claims{grid-template-columns:1fr 0fr;transition:grid 0.6s;gap:0}.blend.claims .blend-text,.blend.claims .blend-selection{opacity:0;transition:opacity 0.3s ease}.blend.claims .selection-group{display:none}.blend.claims .blend-results{height:500px;transition:height 0.6s ease}.blend.claims .result-bg{filter:blur(0px);background-position:0% 0%;background-size:70px;transform:scale(1.5);animation:bganimation 1s ease-in-out 5 forwards}@keyframes bganimation{0%,100%{opacity:0.1}50%{opacity:0.3}}.blend main{display:flex;flex-direction:column;gap:12px 48px}.back{display:flex;align-items:center;gap:12px;color:var(--nb-color);margin-bottom:12px}.back:hover svg{transform:scale(1.1)}.back:active svg{transform:scale(0.9)}.back svg{width:36px;height:36px;transition:transform 0.15s ease;border:var(--nb-border-size) solid var(--nb-border);border-radius:24px;padding:6px}.blend-content{display:flex}.blend-content h1{font-size:var(--nb-font-size--title)}.blend-content span{color:var(--nb-color-secondary)}.blend-content small{padding:0 10px}.blend-content time{text-transform:uppercase}.blend-text{background-color:var(--nb-bg-card);border-radius:var(--nb-radius);padding:12px;overflow:hidden auto}.blend-info{display:flex;justify-content:space-between;flex-wrap:wrap-reverse;gap:12px}.blend-info .banner{margin-left:0}.blend-actions{display:flex;align-items:center;justify-content:center;margin:12px 0}.btn-group{display:flex;align-items:center;gap:12px}.btn-refresh svg{display:block;width:18px;height:18px;transition:transform 0.15s ease}.btn-refresh:hover svg{transform:rotate(60deg)}.blend-results{background-color:var(--nb-bg-card);border-radius:var(--nb-radius);height:350px;position:relative;overflow:hidden;z-index:0}.result-bg{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;filter:blur(120px);transform:translate3d(0, 0, 0);opacity:0.3;z-index:-1;user-select:none}.account-limit{color:var(--nb-color-secondary)}.account-limit span{color:var(--nb-color)}.blend-selection{text-align:center}.blend-selection h2{color:var(--nb-color-secondary);font-size:var(--nb-font-size--large);position:relative;z-index:0;text-align:center}.blend-selection h2::before{content:"";position:absolute;top:calc(50% + 1px);left:0;transform:translateY(-50%);width:100%;height:1px;z-index:-1;background-color:var(--nb-border)}.blend-selection h2::after{content:"";position:absolute;background-color:var(--nb-bg);display:block;filter:blur(3px);transform:translate3d(0, 0, 0);height:100%;left:calc(50% - 120px);top:0;width:240px;z-index:-1}.blend-selection small{color:var(--nb-color-secondary);font-size:var(--nb-font-size--small)}.selection-group{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;width:100%;gap:var(--nb-gap);padding:48px 0 0}.selection-item{display:flex;align-items:center;justify-content:center;width:clamp(180px, 30vw, 220px);aspect-ratio:1/1.2;border-radius:var(--nb-radius);background-color:rgba(0, 0, 0, 0.2);border:var(--nb-border-size) dashed var(--nb-border-card);position:relative}.selection-item>div{width:calc(100% - 4px);height:calc(100% - 4px);background-color:var(--nb-bg-card);border-radius:8px;position:absolute;border:var(--nb-border-size) solid var(--nb-border-card);transition:transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1)}.selection-item>div.needed img,.selection-item>div.needed video{filter:grayscale(1)}.selection-item>div.needed .btn small{font-size:0.8em;margin-left:2px}.selection-item .no-user{display:flex;flex-direction:column;gap:24px;align-items:center;width:100%;position:absolute}.selection-item .no-user svg{width:48px;height:48px;animation:floating 8s ease-in-out infinite}.selection-item .visual{display:flex;align-items:center;justify-content:center;font-weight:700;font-size:var(--nb-font-size--large);width:100%;height:50%;padding:12px;position:relative;overflow:hidden}.selection-item .visual.token img,.selection-item .visual.balance img{width:80%;height:80%;padding:10%}.selection-item .visual--small{font-weight:500;color:var(--nb-color-secondary);font-size:var(--nb-font-size--small)}.selection-item .balance{font-size:var(--nb-font-size--small);color:var(--nb-color-secondary)}.selection-item .balance small{display:block}.selection-item .type{display:inline-block;width:100%;position:relative}.selection-item .type a{position:absolute;top:2px;right:3px;transition:transform 0.15s ease}.selection-item .type a:hover{transform:scale(1.1)}.selection-item .type svg{color:var(--nb-color-secondary);width:18px;height:18px}.selection-item img,.selection-item video{width:100%;height:100%;object-fit:contain}.selection-item h3{margin-bottom:12px;height:21px;padding:0 6px;overflow:hidden}.loading-state{width:100%;height:100%;background:var(--nb-bg-card);border-radius:8px;animation:loading 1.1s ease-in-out infinite}@keyframes loading{0%,100%{opacity:0}50%{opacity:0.5}}@keyframes floating{0%,100%{transform:translate3d(0, 0, 0) rotate(-3deg)}25%{transform:translate3d(2px, -10px, 0) rotate(0deg)}50%{transform:translate3d(0, 0, 0) rotate(3deg)}75%{transform:translate3d(-2px, -10px, 0) rotate(0deg)}}.banner{margin-left:auto;max-width:300px;width:100%;background-color:var(--nb-inactive);padding:12px;border-radius:var(--nb-radius)}.banner p{color:var(--nb-color);font-size:var(--nb-font-size--small)}.banner--warn{background-color:var(--nb-warning)}@media all and (min-width: 768px){.blend{grid-template-columns:1fr 0.3fr;gap:0 48px}.blend.no-text{grid-template-columns:1fr;gap:0px}.blend-text{margin-top:70px;max-height:calc(100vh - var(--nb-markdown-offset))}.selection-item .visual{height:60%}}', this.shadowRoot.appendChild(n), Re(
      this,
      {
        target: this.shadowRoot,
        props: Ge(this.attributes),
        customElement: !0
      },
      Wr,
      Zr,
      xe,
      {},
      null,
      [-1, -1]
    ), e && e.target && w(e.target, this, e.anchor);
  }
}
customElements.define("nefty-blend-item", Fr);
function Xr(t) {
  let e, n, r;
  return {
    c() {
      e = v("nefty-blend-group");
    },
    m(l, i) {
      w(l, e, i), n || (r = se(
        e,
        "blend",
        /*handleBlend*/
        t[2]
      ), n = !0);
    },
    p: X,
    d(l) {
      l && z(e), n = !1, r();
    }
  };
}
function Qr(t) {
  let e, n, r;
  return {
    c() {
      e = v("nefty-blend-item");
    },
    m(l, i) {
      w(l, e, i), n || (r = se(
        e,
        "blend",
        /*handleBlend*/
        t[2]
      ), n = !0);
    },
    p: X,
    d(l) {
      l && z(e), n = !1, r();
    }
  };
}
function Kr(t) {
  let e;
  function n(i, o) {
    return (
      /*blend*/
      i[0] || /*$settings*/
      i[1].blend ? Qr : Xr
    );
  }
  let r = n(t), l = r(t);
  return {
    c() {
      e = v("main"), l.c(), this.c = X;
    },
    m(i, o) {
      w(i, e, o), l.m(e, null);
    },
    p(i, [o]) {
      r === (r = n(i)) && l ? l.p(i, o) : (l.d(1), l = r(i), l && (l.c(), l.m(e, null)));
    },
    i: X,
    o: X,
    d(i) {
      i && z(e), l.d();
    }
  };
}
function el(t, e, n) {
  let r, l, i, o;
  ye(t, be, (b) => n(1, r = b)), ye(t, et, (b) => n(6, l = b)), ye(t, Oe, (b) => n(7, i = b)), ye(t, Ke, (b) => n(8, o = b));
  let { account: s = null } = e, { blend: d = null } = e, { config: c = null } = e, { transactionid: m = null } = e;
  nt(() => () => {
    Me(
      be,
      r = {
        blend: null,
        account: null,
        config: null,
        transactionId: null
      },
      r
    ), Me(Ke, o = [], o), Me(Oe, i = !1, i), Me(et, l = "", l), n(3, s = null), n(0, d = null), n(4, c = null), n(5, m = null);
  });
  const u = (b) => {
    n(0, d = b.detail ? JSON.stringify(b.detail) : null), be.update((_) => (_.blend = b.detail, _));
  };
  return t.$$set = (b) => {
    "account" in b && n(3, s = b.account), "blend" in b && n(0, d = b.blend), "config" in b && n(4, c = b.config), "transactionid" in b && n(5, m = b.transactionid);
  }, t.$$.update = () => {
    if (t.$$.dirty & /*blend, account, $settings, config, transactionid*/
    59) {
      let b = !!d;
      s && s !== JSON.stringify(r.account) && be.update((_) => (_.account = s !== "unset" ? JSON.parse(s) : null, n(3, s = null), _)), d && !r.blend && be.update((_) => (_.blend = JSON.parse(d), n(0, d = null), _)), c && c !== JSON.stringify(r.config) && be.update((_) => {
        const p = JSON.stringify(b && _.config ? { query: _.config.query } : {});
        return _.config = {
          ...JSON.parse(c),
          ...JSON.parse(p)
        }, n(4, c = null), _;
      }), m && be.update((_) => (_.transactionId = m, n(5, m = null), _));
    }
  }, [d, r, u, s, c, m];
}
class tl extends je {
  constructor(e) {
    super(), Re(
      this,
      {
        target: this.shadowRoot,
        props: Ge(this.attributes),
        customElement: !0
      },
      el,
      Kr,
      xe,
      {
        account: 3,
        blend: 0,
        config: 4,
        transactionid: 5
      },
      null
    ), e && (e.target && w(e.target, this, e.anchor), e.props && (this.$set(e.props), me()));
  }
  static get observedAttributes() {
    return ["account", "blend", "config", "transactionid"];
  }
  get account() {
    return this.$$.ctx[3];
  }
  set account(e) {
    this.$$set({ account: e }), me();
  }
  get blend() {
    return this.$$.ctx[0];
  }
  set blend(e) {
    this.$$set({ blend: e }), me();
  }
  get config() {
    return this.$$.ctx[4];
  }
  set config(e) {
    this.$$set({ config: e }), me();
  }
  get transactionid() {
    return this.$$.ctx[5];
  }
  set transactionid(e) {
    this.$$set({ transactionid: e }), me();
  }
}
customElements.define("neftyblocks-blends", tl);
